import React, { useState, useEffect, useRef, use } from 'react';
import { FileText, Globe, Eye, X, Send } from 'lucide-react';
import { MdDelete, MdAdd } from "react-icons/md";
import apiService from '../config';
import html2pdf from 'html2pdf.js';
import { useLanguage } from '../StoreContext/LanguageContext';

export const RailwaySection19 = ({ onUpdated, setSelectedComponent, setSubComponent, modalParams, shouldRestoreModal, onNavigateWithModal, setShouldRestoreModal }) => {
  const [formData, setFormData] = useState({
    // Read-only fields (fetch but don't update)
    acquisition_proposal_no: '',
    acquisition_proposal_date: '',
    propsal_publication_date: '',
    propsal_publication_no: '',

    // Editable fields
    project_description: '',
    project_social_benfit: '',
    // displacement_reason: '',
    section_19_rehabilitation_plan_summary: '',
    appointed_administrator: '',
    project_name: '',
    section_19_content: '',
    section_19_tip: '',
    section_19_bhusampadan_no: '',
    section_19_office_name: '',
    section_19_branch_name: '',
    section_19_notification: '',
    section_19_email: '',
    section_19_address: '',
    section_19_mobile_no: '',
    section_11_bhusampadan_no: '',
    section_11_office_name: '',
    section_11_branch_name: '',
    section_11_notification: '',
    section_11_email: '',
    section_11_address: '',
    section_11_mobile_no: '',
    section_19_date: '',
    section_11_date: '',
    section_19_punarvarshan: '',

    // Data Entry
    section_19_backToLAODate: ''
  });

  // Define which fields are editable
  const editableFields = [
    'project_description',
    'project_social_benfit',
    // 'displacement_reason',
    'section_19_rehabilitation_plan_summary',
    'appointed_administrator',
    // 'project_name',
    'section_19_content',
    'section_19_tip',
    'section_19_bhusampadan_no',
    'section_19_office_name',
    'section_19_branch_name',
    'section_19_notification',
    'section_19_email',
    'section_19_address',
    'section_19_mobile_no',
    'section_19_date',
    'section_19_punarvarshan',

    // Data Entry
    'section_19_backToLAODate'
  ];

  const [loading, setLoading] = useState(false);
  const [loadingRecords, setLoadingRecords] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const notificationContentRef = useRef(null);
  const pdfPreviewRef = useRef(null);
  const [groupedData, setGroupedData] = useState([]);
  const [landData, setLandData] = useState([]);
  const [showPdfPreview, setShowPdfPreview] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);

  const [projectId, setProjectId] = useState(null);
  const [projectName, setProjectName] = useState(null);
  const [proposalId, setProposalId] = useState(null);

  const [hasUserEditedSection1, setHasUserEditedSection1] = useState(false);
  const [hasUserEditedTip, setHasUserEditedTip] = useState(false);
  const [usersCollector, setUsersCollector] = useState([]);
  const [usersLAO, setusersLAO] = useState([]);

  const [publishing, setPublishing] = useState(false);

  const userData = JSON.parse(localStorage.getItem('userData'));
  const userRole = parseInt(userData?.data?.user_role || userData?.user_role, 10);
  const laoName = usersLAO?.[0]?.full_name || 'N/A';
  const laoDesi = usersLAO?.[0]?.designation || 'N/A';
  const laoEmail = usersLAO?.[0]?.email || 'N/A';
  console.log('User Role:', userRole);
  console.log('User Name:', laoName);
  console.log('User Designation:', laoDesi);

  const [showPublishModal, setShowPublishModal] = useState(false);
  const { language, translations } = useLanguage();
  const [selectedDocuments, setSelectedDocuments] = useState({});
  // Documents Viewer state
  const [showDocumentViewer, setShowDocumentViewer] = useState(false);
  const [fileUrlToView, setFileUrlToView] = useState('');
  const [isPDFToView, setIsPDFToView] = useState(false);
  const [isViewMode, setIsViewMode] = useState(false);
  const [editedFields, setEditedFields] = useState({});
  // Publish states
  const [proposalData, setProposalData] = useState({});
  const [publishData, setPublishData] = useState({
    section19_published_gazette_no: '',
    section19_published_gazette: '',
    section19_published_newspaper1_no: '',
    section19_published_newspaper1: '',
    section19_published_newspaper2_no: '',
    section19_published_newspaper2: '',
    section19_municipal_authority_no: '',
    section19_municipal_authority: '',
    section19_collector_office_no: '',
    section19_collector_office: '',
    section19_sub_divisional_office_no: '',
    section19_sub_divisional_office: '',
    section19_tehsil_office_no: '',
    section19_tehsil_office: '',
    section19_government_notice_board_no: '',
    section19_government_notice_board: '',
    section19_gram_sevak_office_no: '',
    section19_gram_sevak_office: '',
    section19_gram_panchayat_office_no: '',
    section19_gram_panchayat_office: '',
    section19_rehabilitation_rights_notice_no: '',
    section19_rehabilitation_rights_notice: '',

  });

  // Image upload states
  const [uploadedImages, setUploadedImages] = useState({
    // proposal_proceding: null,
    // administrative_order: null,
    // proposal_publication: null,
    // acquisition_proposal: null,
    // date_extension: null,
    // appointed_admin: null,
    // newspaper: null,
    // gazette: null,
    // exemptionFile: null // This will hold the File object for upload
    section19_published_gazette_img: '',
    section19_published_newspaper1_img: '',
    section19_published_newspaper2_img: '',
    section19_municipal_authority_img: '',
    section19_collector_office_img: '',
    section19_sub_divisional_office_img: '',
    section19_tehsil_office_img: '',
    section19_government_notice_board_img: '',
    section19_gram_sevak_office_img: '',
    section19_gram_panchayat_office_img: '',
    section19_rehabilitation_rights_notice_img: '',
  });

  // Punarvarshan
  const [punarvarshanData, setPunarvarshanData] = useState([]);
  const [punarvarshanGroupedData, setPunarvarshanGroupedData] = useState([]);
  const [uploadPunarvarshanData, setUploadPunarvarshan] = useState({
    dist_name: '',
    taluka_name: '',
    village_name: '',
    survey_no: '',
    aquire_area: '',
  });
  // Add one more state for edit mode row
  const [editingRow, setEditingRow] = useState(null);
  const [deletedRecords, setDeletedRecords] = useState([]);

  // Location
  const [districts, setDistricts] = useState([]);
  const [talukas, setTalukas] = useState({});
  const [villages, setVillages] = useState({});

  // Samanvay
  const [showSendToSamanvayModal, setshowSendToSamanvayModal] = useState(false);
  const [selectedDocumentSamanvay, setselectedDocumentSamanvay] = useState(null);
  const [remarksSamanvay, setremarksSamanvay] = useState('Approved');
  const [sendingToSamanvay, setsendingToSamanvay] = useState(false);
  const [usersSamanvay, setusersSamanvay] = useState([]);
  const [loadingusersSamanvay, setLoadingusersSamanvay] = useState(false);
  const [selectedUserSamanvay, setselectedUserSamanvay] = useState('');
  // Collector
  const [showSendToCollectorModal, setshowSendToCollectorModal] = useState(false);
  const [selectedDocumentCollector, setselectedDocumentCollector] = useState(null);
  const [remarksCollector, setremarksCollector] = useState('Approved');
  const [sendingToCollector, setsendingToCollector] = useState(false);
  const [usersCollectorAll, setusersCollectorAll] = useState([]);
  const [loadingusersCollector, setLoadingusersCollector] = useState(false);
  const [selectedUserCollector, setselectedUserCollector] = useState('');
  // LAO
  const [showSendToLAOModal, setshowSendToLAOModal] = useState(false);
  const [selectedDocumentLAO, setselectedDocumentLAO] = useState(null);
  const [remarksLAO, setremarksLAO] = useState('Approved');
  const [sendingToLAO, setsendingToLAO] = useState(false);
  // const [usersLAO, setusersLAO] = useState([]);
  const [loadingusersLAO, setLoadingusersLAO] = useState(false);
  const [selectedUserLAO, setselectedUserLAO] = useState('');
  // Button Status
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [collectorEditCompletedbuttonDisabled, setCollectorEditCompletedbuttonDisabled] = useState(false);

  // ADD THESE NEW STATE VARIABLES HERE:
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [alertConfig, setAlertConfig] = useState({
    title: '',
    message: '',
    type: 'success'
  });
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmConfig, setConfirmConfig] = useState({
    title: '',
    message: '',
    onConfirm: null,
    onCancel: null,
    type: 'warning'
  });

  const ROLES = {
    COLLECTOR: 1,
    LAO: 3,
    SAMANVAY: 6,
    PROJECT_INCHARGE: 18,
    DATA_ENTRY: 14
  };

  const tableRef = useRef(null);

  // Project Id
  useEffect(() => {
    const getProjectInfo = () => {
      const currentProjectData = localStorage.getItem('currentProjectData');
      if (currentProjectData) {
        try {
          const projectData = JSON.parse(currentProjectData);
          return {
            id: projectData.project_id || projectData.id,
            name: projectData.project_name || projectData.name
          };
        } catch (e) {
          console.error('Error parsing current project data (currentProjectData):', e);
        }
      }

      const selectedProject = localStorage.getItem('selectedProject');
      if (selectedProject) {
        try {
          const project = JSON.parse(selectedProject);
          return {
            id: project.project_id || project.id,
            name: project.project_name || project.name
          };
        } catch (e) {
          console.error('Error parsing selected project (selectedProject):', e);
        }
      }

      const userData = localStorage.getItem('userData');
      if (userData) {
        try {
          const user = JSON.parse(userData);
          const projectId = user.data?.project_id || user.project_id;
          const projectName = user.data?.project_name || user.project_name || 'Unknown Project';
          return {
            id: projectId,
            name: projectName
          };
        } catch (e) {
          console.error('Error parsing user data (userData):', e);
        }
      }
      return { id: null, name: null };
    };

    const projectInfo = getProjectInfo();
    setProjectId(projectInfo.id);
    setProjectName(projectInfo.name);
    console.log('Current Project Info:', projectInfo);
  }, []);

  // Proposal id
  useEffect(() => {
    const getProposalInfo = () => {
      const currentProposal = JSON.parse(localStorage.getItem('userData') || '{}');

      if (currentProposal) {
        try {
          return {
            proposalId: currentProposal?.data?.default_proposal ||
              currentProposal?.data?.proposal_id ||
              currentProposal?.default_proposal ||
              currentProposal?.proposal_id ||
              null
          }
        } catch (e) {
          console.error('Error parsing current project data (getProposalInfo):', e);
        }
      }
      return { proposalId: null };
    };

    const proposalInfo = getProposalInfo();
    setProposalId(proposalInfo.proposalId);
    console.log('Current Project-Proposal Info:', proposalInfo);
  }, []);


  useEffect(() => {
    allApi();
  }, [projectId && proposalId]);

  const allApi = () => {
    if (projectId && proposalId) {
      fetchLandHoldingData();
      fetchOwnerData();
      fetchusersLAO();
      fetchPunarvarshanData();
      fetchButtonStatus();
    }
  }
  useEffect(() => {
    if (showSendToCollectorModal) {
      fetchUsersAllCollector();
    }
  }, [showSendToCollectorModal]);

  useEffect(() => {
    if (showSendToSamanvayModal) {
      fetchusersSamanvay();
    }
  }, [showSendToSamanvayModal]);

  // Fetch data when component mounts
  // useEffect(() => {
  //   console.warn("Section19 mounted with:", { projectId, proposalId });
  //   fetchLandHoldingData();
  // }, [projectId, proposalId]);

  // Restore modal state from parameters
  useEffect(() => {
    if (shouldRestoreModal && modalParams) {

      setshowSendToCollectorModal(true);
      fetchUsersAllCollector();

      // Restore previous selections
      pendingRestore.current = {
        user: modalParams.selectedUser || '',
        remarks: modalParams.remarks || '',
      };

      // Set COLLECTOR remarks, not Samanvay remarks
      setremarksCollector(modalParams.remarks || '');

      // Reset flag so modal doesn't restore again automatically
      if (setShouldRestoreModal) {
        setShouldRestoreModal(false);
      }
    }
  }, [shouldRestoreModal, modalParams, setShouldRestoreModal]);

  useEffect(() => {
    if (pendingRestore.current) {
      if (usersCollectorAll.length > 0) {
        setselectedUserCollector(pendingRestore.current.user);
        setremarksCollector(pendingRestore.current.remarks);

        pendingRestore.current = null; // clear after applying
      }
    }
  }, [usersCollectorAll]);

  const pendingRestore = useRef(null);

  // Navigate to covering letters with modal state
  const handleCoveringLetterClick = () => {
    console.log('handleCoveringLetterClick called');
    console.log('onNavigateWithModal type:', typeof onNavigateWithModal);

    // Add validation
    if (typeof onNavigateWithModal !== 'function') {
      console.error('onNavigateWithModal is not a function:', onNavigateWithModal);
      alert('Navigation function is not available. Please check the component props.');
      return;
    }

    const modalState = {
      selectedUser: selectedUserCollector,
      userId: selectedUserCollector,
      remarks: remarksCollector,
      selectedDocumentName: selectedDocumentCollector?.name || null,
      timestamp: new Date().getTime()
    };

    console.log('Modal state for covering letters:', modalState);

    // Close the modal before navigating
    setshowSendToCollectorModal(false);

    // Use the correct component name for Section 19
    console.log('Calling onNavigateWithModal with CoveringLettersSection11');
    onNavigateWithModal('CoveringLettersSection19', modalState);
  };

  // fetch Collector
  useEffect(() => {
    const fetchUsersCollector = async () => {
      try {
        const response = await apiService.getAllUserCollector();
        console.log('Collector users:', response);
        if (response.status === 200 && response.data) {
          console.log("----------Collector users fetched successfully:", response.data);
          setUsersCollector(Array.isArray(response.data) ? response.data : []);
        } else {
          setUsersCollector([]);
        }
      } catch (error) {
        console.error('Error fetching Collector users:', error);
        setUsersCollector([]);
      } finally {

      }
    };
    fetchUsersCollector();
  }, []);

  const checkIfDataComplete = (data) => {
    const requiredFields = [
      'section19_published_gazette',
      'section19_published_newspaper1',
      'section19_published_newspaper2',
      'section19_municipal_authority',
      'section19_collector_office',
      'section19_sub_divisional_office',
      'section19_tehsil_office',
      'section19_government_notice_board',
      'section19_gram_sevak_office',
      'section19_rehabilitation_rights_notice'
    ];

    return requiredFields.every(field => data[field] && data[field].trim() !== '');
  };

  useEffect(() => {
    // Only auto-update row 11 date when in edit mode
    if (!isViewMode) {
      // Collect dates from row 1–10
      const dates = [
        publishData.section19_published_gazette,
        publishData.section19_published_newspaper1,
        publishData.section19_published_newspaper2,
        publishData.section19_municipal_authority,
        publishData.section19_collector_office,
        publishData.section19_sub_divisional_office,
        publishData.section19_tehsil_office,
        publishData.section19_government_notice_board,
        publishData.section19_gram_sevak_office
      ].filter(Boolean); // remove empty/null values

      if (dates.length > 0) {
        // find the latest date
        const latestDate = dates.reduce((a, b) => (a > b ? a : b));

        // update row 11's date if different
        if (publishData.section19_rehabilitation_rights_notice !== latestDate) {
          setPublishData((prev) => ({
            ...prev,
            section19_rehabilitation_rights_notice: latestDate
          }));
        }
      }
    }
  }, [
    publishData.section19_published_gazette,
    publishData.section19_published_newspaper1,
    publishData.section19_published_newspaper2,
    publishData.section19_municipal_authority,
    publishData.section19_collector_office,
    publishData.section19_sub_divisional_office,
    publishData.section19_tehsil_office,
    publishData.section19_government_notice_board,
    publishData.section19_gram_sevak_office,
    isViewMode
  ]);

  const maxDateOf10 = [
    publishData.section19_published_gazette,
    publishData.section19_published_newspaper1,
    publishData.section19_published_newspaper2,
    publishData.section19_municipal_authority,
    publishData.section19_collector_office,
    publishData.section19_sub_divisional_office,
    publishData.section19_tehsil_office,
    publishData.section19_government_notice_board,
    publishData.section19_gram_sevak_office,
    publishData.section19_gram_panchayat_office,
  ]
    .filter(Boolean)
    .reduce((a, b) => (a > b ? a : b), '');

  const fetchLandHoldingData = async () => {

    // Add validation to ensure both IDs are valid numbers
    if (!projectId || !proposalId || projectId <= 0 || proposalId <= 0) {
      console.log('Invalid project or proposal ID:', { projectId, proposalId });
      return;
    }

    const locationParams = { proposalId };
    console.log('Fetching Prathmik Adhisuchna data with:', locationParams);
    console.log('Fetching Prathmik Adhisuchna data with: -', projectId);

    try {
      setLoadingRecords(true);
      console.log("---------------------------1");

      const result = await apiService.getLandHolding(projectId, locationParams);
      console.log("---------------------------2");

      // proposal data - Remove _lao logic
      if (result.status === 200 && Array.isArray(result.proposalData) && result.proposalData.length > 0) {
        const item = result.proposalData[0]; // Taking first record for proposal data

        const newFormData = {};
        Object.keys(formData).forEach(key => {
          newFormData[key] = item[key] !== undefined && item[key] !== null ? item[key] : '';
        });
        setFormData(newFormData);

        // Check if section_19_content exists in API data
        if (item.section_19_content &&
          item.section_19_content.trim() !== '' &&
          item.section_19_content !== 'N/A' &&
          item.section_19_content !== 'null' &&
          item.section_19_content !== 'undefined') {
          setHasUserEditedSection1(true); // Mark as having API content
        }
        if (item.section_19_tip &&
          item.section_19_tip.trim() !== '' &&
          item.section_19_tip !== 'N/A' &&
          item.section_19_tip !== 'null' &&
          item.section_19_tip !== 'undefined') {
          setHasUserEditedTip(true); // Mark as having API content
        }
      }

      fetchProposalData();
    } catch (error) {
      console.error('Error fetching Prathmik Adhisuchna data:', error);
      // alert('❌ Error fetching proposal data.');
    } finally {
      setLoadingRecords(false);
    }
  };

  const fetchOwnerData = async () => {

    // Add validation to ensure both IDs are valid numbers
    if (!projectId || !proposalId || projectId <= 0 || proposalId <= 0) {
      console.log('Invalid project or proposal ID:', { projectId, proposalId });
      return;
    }

    const locationParams = { proposalId };
    console.log('Fetching Prathmik Adhisuchna data with:', locationParams);
    console.log('Fetching Prathmik Adhisuchna data with: -', projectId);

    try {
      setLoadingRecords(true);
      console.log("---------------------------1");

      const result = await apiService.get("getAllOwner", {
        projectId: projectId,
        proposalId: proposalId,
        isActive: 1
      });
      console.log("---------------------------2");

      // Land Acquisition data
      if (result.status === 200 && Array.isArray(result.landAcquisition)) {
        const grouped = {};
        const groupedLand = {};

        result.landAcquisition.forEach(item => {
          // Only include if owners array exists and has data
          if (Array.isArray(item.owners) && item.owners.length > 0) {
            const key = `${item.dist_name}-${item.taluka_name}-${item.village_name}`;
            if (!grouped[key]) {
              grouped[key] = [];
            }

            // Push each owner as a separate record
            item.owners.forEach(owner => {
              grouped[key].push({
                survey_no: owner.survey_no,
                aqr_area: owner.owner_aqr_area,
                total_area: parseFloat(item.total_area || 0),
                owner_irrigable_area: owner.owner_irrigable_area || 0,
                owner_non_irrigable_area: owner.owner_non_irrigable_area || 0
              });
            });
          }

          // Irrigable
          const landKey = `${item.dist_name}-${item.taluka_name}-${item.village_name}`;
          if (!groupedLand[landKey]) {
            groupedLand[landKey] = [];
          }

          groupedLand[landKey].push({
            survey_no: item.survey_no,
            irrigable_area: item.irrigable_area,
            non_irrigable_area: item.non_irrigable_area,
            total_area: parseFloat(item.total_area || 0),
          })

        });

        // Convert to array for rendering
        const groupedArray = Object.entries(grouped).map(([key, records]) => {
          const [dist, taluka, village] = key.split('-');

          // Owner
          const ownerTotalIrrigable = records.reduce(
            (sum, r) => sum + parseFloat(r.owner_irrigable_area || 0),
            0
          );

          const ownerTotalNonIrrigable = records.reduce(
            (sum, r) => sum + parseFloat(r.owner_non_irrigable_area || 0),
            0
          );

          const total = records.reduce((sum, r) => sum + parseFloat(r.aqr_area || 0), 0);
          return { dist, taluka, village, records, total, ownerTotalIrrigable, ownerTotalNonIrrigable };
        });

        const holderData = Object.entries(groupedLand).map(([key, records]) => {
          const [dist, taluka, village] = key.split('-');
          const irrigableTotal = records.reduce((sum, r) => sum + parseFloat(r.irrigable_area || 0), 0);
          const nonIrrigableTotal = records.reduce((sum, r) => sum + parseFloat(r.non_irrigable_area || 0), 0);
          const finalTotal = records.reduce((sum, r) => sum + parseFloat(r.total_area || 0), 0);
          return { dist, taluka, village, records, irrigableTotal, nonIrrigableTotal, finalTotal };
        });

        setGroupedData(groupedArray);
        setLandData(holderData);
      }

      fetchProposalData();
    } catch (error) {
      console.error('Error fetching Prathmik Adhisuchna data:', error);
      // alert('❌ Error fetching proposal data.');
    } finally {
      setLoadingRecords(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Only allow changes to editable fields
    if (editableFields.includes(name)) {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));

      // If user is editing section_19_content, mark it as edited
      // if (name === 'section_19_content') {
      //   setHasUserEditedSection1(true);
      // }
      // if (name === 'section_19_tip') {
      //   setHasUserEditedTip(true);
      // }
      setEditedFields(prev => ({
        ...prev,
        [name]: true
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!proposalId) {
      alert('❌ No proposal ID found for update.');
      return;
    }

    try {
      setLoading(true);
      setIsViewMode(false);

      // First, update the main proposal data
      const updateData = {
        section_19_date: formData.section_19_date || formData.section_11_date || new Date(),
        section_19_mobile_no: formData.section_19_mobile_no || formData.section_11_mobile_no || '',
        section_19_office_name: formData.section_19_office_name || formData.section_11_office_name || '',
        section_19_branch_name: formData.section_19_branch_name || formData.section_11_branch_name || '',
        section_19_notification: formData.section_19_notification || formData.section_11_notification || '',
        section_19_email: formData.section_19_email || formData.section_11_email || laoEmail || '',
        section_19_address: formData.section_19_address || formData.section_11_address || '',
        section_19_bhusampadan_no: formData.section_19_bhusampadan_no || formData.section_11_bhusampadan_no || '',
        section_19_rehabilitation_plan_summary: formData.section_19_rehabilitation_plan_summary,
        appointed_administrator: formData.appointed_administrator,
        project_description: formData.project_description,
        project_social_benfit: formData.project_social_benfit,

        // only add this key if value exists
        ...(formData.section_19_punarvarshan && {
          section_19_punarvarshan: formData.section_19_punarvarshan,
        }),

        section_19_content: formData.section_19_content?.trim()
          ? formData.section_19_content
          : getDefaultSection1Content(),

        section_19_tip: formData.section_19_tip?.trim()
          ? formData.section_19_tip
          : getDefaultTip(),
      };

      // Data Entry
      if (userRole === ROLES.DATA_ENTRY) {
        updateData.section_19_backToLAODate = formData.section_19_backToLAODate
      }

      // Update main proposal
      const result = await apiService.updateProposal(proposalId, updateData);

      if (result.status === 200) {
        // Process Punarvarshan records after successful proposal update
        await processPunarvarshanRecords();

        alert(translations[language]?.Section19UpdatedSuccessfully);
        setIsEditing(false);
        if (onUpdated) onUpdated();
        allApi(); // Refresh all data
      } else {
        alert('❌ Failed to update proposal.');
      }
    } catch (err) {
      console.error('Error updating proposal:', err);
      alert('❌ Error while updating proposal.');
    } finally {
      setLoading(false);
    }
  };

  const fetchPunarvarshanData = async () => {
    if (!projectId || !proposalId) {
      console.log('Invalid project or proposal ID:', { projectId, proposalId });
      return;
    }

    try {
      setLoadingRecords(true);

      const result = await apiService.get("getPunarvarshan", {
        projectId: projectId,
        proposalId: proposalId
      });

      if (result.status === 200 && Array.isArray(result.data) && result.data.length > 0) {
        setPunarvarshanData(
          result.data.map(item => ({
            id: item.punarvarshan_id,      // use API id
            survey_no: item.survey_no,
            aquire_area: item.aquire_area,
            dist_name: item.dist_name,
            taluka_name: item.taluka_name,
            village_name: item.village_name
          }))
        );
        // Group data by dist-taluk-village
        const grouped = {};

        result.data.forEach(item => {
          const key = `${item.dist_name}-${item.taluka_name}-${item.village_name}`;
          if (!grouped[key]) {
            grouped[key] = [];
          }

          grouped[key].push({
            id: item.punarvarshan_id,
            survey_no: item.survey_no,
            aquire_area: item.aquire_area
          });
        });

        // Convert into array format for rendering
        const groupedArray = Object.entries(grouped).map(([key, records]) => {
          const [dist, taluka, village] = key.split('-');
          const total = records.reduce((sum, r) => sum + parseFloat(r.aquire_area || 0), 0);
          return { dist, taluka, village, records, total };
        });

        setPunarvarshanGroupedData(groupedArray);
      }

    } catch (error) {
      console.error('Error fetching Punarvarshan data:', error);
    } finally {
      setLoadingRecords(false);
    }
  };

  // Change row data when editing
  const handleEditRowChange = (id, field, value) => {
    setPunarvarshanData(prev =>
      prev.map(record =>
        record.id === id ? { ...record, [field]: value } : record
      )
    );
  };

  // Process all Punarvarshan records (flat array)
  const processPunarvarshanRecords = async () => {
    try {
      let promises = [];

      for (const record of punarvarshanData) {
        if (record.id && record.id.toString().length < 13) {
          // Existing record → UPDATE
          if (record.survey_no !== "" && record.aquire_area !== "") {
            promises.push(handleUpdatePunarvarshanRecord(record));
          }
        } else if (record.id && record.id.toString().length >= 13) {
          // New record (temporary ID from Date.now()) → ADD
          if (record.survey_no !== "" && record.aquire_area !== "") {
            promises.push(handleAddPunarvarshanRecord(record));
          }
        }
      }

      // Handle any deleted records
      promises.push(handleDeletedPunarvarshanRecords());

      await Promise.all(promises);

    } catch (error) {
      console.error("Error processing Punarvarshan records:", error);
      throw error;
    }
  };

  // ADD new Punarvarshan record
  const handleAddPunarvarshanRecord = async (record) => {
    try {
      const payload = {
        project_id: projectId,
        proposal_id: proposalId,
        survey_no: record.survey_no,
        aquire_area: record.aquire_area,
        dist_name: record.dist_name,
        taluka_name: record.taluka_name,
        village_name: record.village_name,
      };

      const api = await apiService.postPunarvarshan(payload);

      if (api.status === 200) {
        console.log(`✅ Added new Punarvarshan record: ${record.survey_no}`);
      }
    } catch (err) {
      console.error("Error adding Punarvarshan record:", err);
      throw err;
    }
  };

  // UPDATE existing Punarvarshan record
  const handleUpdatePunarvarshanRecord = async (record) => {
    try {
      const payload = {
        survey_no: record.survey_no,
        aquire_area: record.aquire_area,
        dist_name: record.dist_name,
        taluka_name: record.taluka_name,
        village_name: record.village_name,
      };

      const api = await apiService.patchPunarvarshan(record.id, payload);

      if (api.status === 200) {
        console.log(`✅ Updated Punarvarshan record ID: ${record.id}`);
      }
    } catch (err) {
      console.error("Error updating Punarvarshan record:", err);
      throw err;
    }
  };

  // DELETE records
  const handleDeletedPunarvarshanRecords = async () => {
    if (deletedRecords && deletedRecords.length > 0) {
      for (const recordId of deletedRecords) {
        try {
          await apiService.delete("deletePunarvarshan", { punarvarshanId: recordId });
          console.log(`✅ Deleted Punarvarshan record ID: ${recordId}`);
        } catch (err) {
          console.error(`Error deleting Punarvarshan record ID ${recordId}:`, err);
        }
      }
      setDeletedRecords([]); // clear after processing
    }
  };

  // DELETE row from UI + track for backend delete
  const handleDeleteRow = (id, index) => {
    if (!window.confirm("Are you sure you want to delete this record?")) return;

    if (id && id.toString().length < 13) {
      // Existing record → mark for backend deletion
      setDeletedRecords((prev) => [...prev, id]);
    }

    // Remove from UI
    setPunarvarshanData((prev) => prev.filter((_, i) => i !== index));
  };

  // ADD a new row in UI
  // const handleAddRow = () => {
  //   const newRow = {
  //     id: Date.now(), // temporary ID
  //     survey_no: "",
  //     aquire_area: "",
  //     dist_name: "",
  //     taluka_name: "",
  //     village_name: "",
  //   };

  //   setPunarvarshanData((prev) => [...(prev || []), newRow]);
  // };
  const handleAddRow = () => {
    setPunarvarshanData((prev) => {
      // find last record
      const lastRecord = prev[prev.length - 1] || {};

      const newRecord = {
        id: Date.now(),
        survey_no: "",
        aquire_area: "",
        dist_name: lastRecord.dist_name || "",
        taluka_name: lastRecord.taluka_name || "",
        village_name: lastRecord.village_name || "",
      };

      return [...prev, newRecord];
    });
  };

  useEffect(() => {
    const fetchDistricts = async () => {
      try {
        const res = await apiService.getDistricts();
        if (res.status === 200) {
          setDistricts(res.data || []);
        }
      } catch (err) {
        console.error("Error fetching districts:", err);
      }
    };
    fetchDistricts();
  }, []);

  useEffect(() => {
    const fetchTalukas = async () => {
      // find unique district names from all records
      const uniqueDists = [...new Set(punarvarshanData.map(r => r.dist_name).filter(Boolean))];

      for (const distName of uniqueDists) {
        try {
          const res = await apiService.getTalukas(distName);
          if (res.status === 200) {
            setTalukas(prev => ({ ...prev, [distName]: res.data }));
          }
        } catch (err) {
          console.error(`Error fetching talukas for ${distName}:`, err);
        }
      }
    };

    if (punarvarshanData.some(r => r.dist_name)) {
      fetchTalukas();
    }
  }, [punarvarshanData.map(r => r.dist_name).join(",")]);

  useEffect(() => {
    const fetchVillages = async () => {
      for (const record of punarvarshanData) {
        if (record.dist_name && record.taluka_name) {
          const key = `${record.dist_name}-${record.taluka_name}`;
          try {
            const res = await apiService.getVillages(record.dist_name, record.taluka_name);
            if (res.status === 200) {
              setVillages(prev => ({ ...prev, [key]: res.data }));
            }
          } catch (err) {
            console.error(`Error fetching villages for ${key}:`, err);
          }
        }
      }
    };

    if (punarvarshanData.some(r => r.taluka_name)) {
      fetchVillages();
    }
  }, [punarvarshanData.map(r => `${r.dist_name}-${r.taluka_name}`).join(",")]);

  // Alternative method using browser's native print functionality
  const handlePrintView = () => {
    // Create a new window with print-optimized content
    const printWindow = window.open('', '_blank');

    if (!printWindow) {
      alert('Please allow popups to use the print feature.');
      return;
    }

    // Get the content
    const content = notificationContentRef.current.innerHTML;

    // Create HTML for print window
    const printHTML = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <title>कलम 19 ची अधिसूचना</title>
      <link href="https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@400;600;700&display=swap" rel="stylesheet">
      <style>
        @page {
          size: A4 portrait;   /* Orientation */
          margin-top: 0.19in;
          margin-bottom: 0.25in;
          margin-left: 0.81in;
          margin-right: 0.5in;
        }
          
        body {
          font-family: 'DVOT-Surekh', 'Mangal', 'Arial', sans-serif;
        }
        
        * {
          box-sizing: border-box;
        }
          
        .print-container {
          width: 100%;
          max-width: none;
          background: white;
        }
        
        .pr-3{
          padding-right:1rem;
        }
        
        table {
          width: 100%;
          border-collapse: collapse;
          margin-bottom: 1rem;
          page-break-inside: auto !important;
        }
  
        thead {
    display: table-header-group;
  }

 tr {
    page-break-inside: avoid;
    page-break-after: auto;
  }

        td, th {
          border: 1px solid black;
    padding: 8px;
    text-align: center;
    font-size: 11px;
    page-break-inside: avoid;
        }
        
        h1, h2, h3, h4, h5, h6 {
          margin: 1rem 0 0.5rem 0;
          page-break-after: avoid;
          font-weight: bold;
        }
        
        p {
          margin: 0.5rem 0;
          text-align: justify;
          line-height: 1.5;
          orphans: 3;
          widows: 3;
        }
        .text-2xl { font-size: 1.8rem; }
        .flex { display: flex; }
        .justify-between { justify-content: space-between; }
        .items-end { align-items: flex-end; }
        .text-center { text-align: center; }
        .mt-44 { margin-top: 1rem; }
        .m-10{ margin: 5rem; }

        .text-center {
          text-align: center;
        }
        
        .font-bold {
          font-weight: bold;
        }
        
        .underline {
          text-decoration: underline;
        }
        
        .indent-8 {
          text-indent: 2rem;
        }
        
        .mt-8 {
          margin-top: 2rem;
        }
        
        .mb-2 {
          margin-bottom: 0.5rem;
        }
        
        .mb-6 {
          margin-bottom: 1.5rem;
        }
        
        .flex { display: flex; }
        
        .justify-center{ justify-content: center; }

        .w-auto{
          width:auto;
          max-width: 28rem;
        }

        .space-y-4 > * + * {
          margin-top: 1rem;
        }
        
        .mx-auto{
          margin-left: auto;
          margin-right: auto;
          width : 8%;
          margin-bottom:2px;
        }

        .border-black{
          border : 1.5px solid black;
        }

        @media print {
          body {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
          
          .page-break {
            page-break-after: always;
          }
          
          table {
            page-break-inside: avoid;
          }
          
          tr {
            page-break-inside: avoid;
          }
          
          table {
            page-break-inside: auto !important;
          }

          thead {
            display: table-header-group; /* repeat header on each page */
          }

          tfoot {
            display: table-footer-group;
          }

          tr {
            page-break-inside: avoid; /* avoid breaking inside a single row */
            page-break-after: auto;
          }

          td, th {
            page-break-inside: avoid;
            page-break-after: auto;
          }

          .page-break-avoid {
            page-break-inside: avoid;
            break-inside: avoid;
          }
        }
      </style>
    </head>
    <body>
      <div class="print-container">
        ${content}
      </div>
      <script>
        window.onload = function() {
          window.focus();
          window.print();
        };
      </script>
    </body>
    </html>
  `;

    printWindow.document.write(printHTML);
    printWindow.document.close();
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const formatDateForInput = (dateString) => {
    // If no date provided, use today
    if (!dateString) {
      const today = new Date();
      return today.toISOString().split('T')[0]; // yyyy-mm-dd
    }

    const date = new Date(dateString);

    // Check if date is invalid OR default 1900 date
    if (isNaN(date) || date.getFullYear() === 1900) {
      const today = new Date();
      return today.toISOString().split('T')[0];
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  };

  const renderAnusuchiOneTable = () => (
    <div>
      <div className='text-center font-semibold text-sm'>संपादित करावयाच्या जमिनीचे वर्णन</div>
      {groupedData.map((group, gIndex) => (
        // <div key={gIndex} style={{ pageBreakAfter: 'always' }}>
        <div>
          <h3 className="text-center text-xs m-2">
            गाव: <span className="font-bold pr-3">{group.village}</span>
            तालुका: <span className="font-bold pr-3">{group.taluka}</span>
            जिल्हा: <span className="font-bold">{group.dist}</span>
          </h3>

          <div className="w-full">
            <table className="border border-black border-collapse mb-4 text-sm w-full">
              <thead>
                <tr className="bg-gray-200">
                  <th rowSpan="2" className="border border-black p-2 text-center">अ. क्र.</th>
                  <th rowSpan="2" className="border border-black p-2 text-center">गट क्रमांक</th>
                  <th colSpan="3" className="border border-black p-2 text-center">संपादित क्षेत्र</th>
                </tr>
                <tr className="bg-gray-200">
                  <th className="border border-black p-2 text-center">लागवड योग्य क्षेत्र (हे.आर)</th>
                  <th className="border border-black p-2 text-center">पोट खराब क्षेत्र (हे.आर)</th>
                  <th className="border border-black p-2 text-center">एकुण क्षेत्र (हे.आर)</th>
                </tr>
              </thead>

              <tbody>
                {group.records.map((record, index) => (
                  <tr key={index}>
                    <td className="border border-black p-2 text-center">{index + 1}</td>
                    <td className="border border-black p-2 text-center">{record.survey_no}</td>
                    <td className="border border-black p-2 text-center">{parseFloat(record.owner_irrigable_area || 0).toFixed(2)} </td>
                    <td className="border border-black p-2 text-center">{parseFloat(record.owner_non_irrigable_area || 0).toFixed(2)} </td>
                    <td className="border border-black p-2 text-center">
                      {(
                        parseFloat(record.owner_irrigable_area || 0) +
                        parseFloat(record.owner_non_irrigable_area || 0)
                      ).toFixed(2)}
                    </td>

                  </tr>
                ))}
                <tr>
                  <td colSpan="2" className="border border-black p-2 font-bold text-right">एकूण क्षेत्र</td>
                  <td className="border border-black p-2 font-bold text-center">{parseFloat(group.ownerTotalIrrigable || 0).toFixed(2)} </td>
                  <td className="border border-black p-2 font-bold text-center">{parseFloat(group.ownerTotalNonIrrigable || 0).toFixed(2)} </td>
                  <td className="border border-black p-2 font-bold text-center">
                    {parseFloat(
                      (group.ownerTotalIrrigable || 0) + (group.ownerTotalNonIrrigable || 0)
                    ).toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      ))}

    </div>
  );

  const renderAnusuchiThreeTable = () => (
    <div>
      {punarvarshanGroupedData && punarvarshanGroupedData.length > 0 ? (
        punarvarshanGroupedData.map((group, gIndex) => (
          <div key={gIndex}>
            <h3 className="text-center text-xs m-2">
              गाव: <span className="font-bold pr-3">{group.village}</span>
              तालुका: <span className="font-bold pr-3">{group.taluka}</span>
              जिल्हा: <span className="font-bold">{group.dist}</span>
            </h3>

            <div className="w-full">
              <table className="border border-black border-collapse mb-4 text-sm w-full">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="border border-black p-2 text-center">अनुक्रमांक</th>
                    <th className="border border-black p-2 text-center">भूमापन क्रमांक</th>
                    <th className="border border-black p-2 text-center">संपादित क्षेत्र (हेक्टर)</th>
                  </tr>
                </thead>
                <tbody>
                  {group.records.map((record, index) => (
                    <tr key={index}>
                      <td className="border border-black p-2 text-center">{index + 1}</td>
                      <td className="border border-black p-2 text-center">{record.survey_no}</td>
                      <td className="border border-black p-2 text-center">
                        {parseFloat(record.aquire_area || 0).toFixed(2)}
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td colSpan="2" className="border border-black p-2 font-bold text-right">
                      एकूण
                    </td>
                    <td className="border border-black p-2 font-bold text-center">
                      {parseFloat(group.total || 0).toFixed(2)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        ))
      ) : (
        <div className="text-xs mt-2">
          {getFieldValue('section_19_punarvarshan', '')}
        </div>
      )}
    </div>
  );

  if (loadingRecords) {
    return (
      <div className="p-6 max-w-7xl mx-auto">
        <div className="flex justify-center items-center h-80">
          <div className="text-center animate-float">
            <div className="inline-flex relative">
              <div className="w-16 h-16 rounded-full border-4 border-slate-700 border-t-transparent animate-spin"></div>
              <div className="w-16 h-16 rounded-full border-4 border-purple-500 border-b-transparent border-r-transparent animate-spin absolute inset-0" style={{ animationDuration: '1.5s', animationDirection: 'reverse' }}></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <FileText className="h-6 w-6 text-purple-400 animate-pulse" />
              </div>
            </div>
            <p className="text-gray-400 mt-4">{translations[language]?.LoadingSection19}</p>
          </div>
        </div>
      </div>
    );
  }

  // Helper function to get field value or fallback
  const getFieldValue = (primaryKey, fallbackKey, defaultValue = '') => {
    if (fallbackKey && typeof fallbackKey === "string") {
      return formData[primaryKey] || formData[fallbackKey] || defaultValue;
    } else {
      return formData[primaryKey] || fallbackKey || defaultValue;
    }
  };

  // UPDATED: Default Section 1 content function
  const getDefaultSection1Content = () => {
    return `ज्याअर्थी समुचित शासन असलेल्या ${groupedData && groupedData.length > 0
      ? [...new Set(groupedData.map(item => item.dist))].join(', ')
      : 'N/A'} जिल्ह्यातल्या जिल्हाधिका-याने भूमिसंपादन, पुनर्वसन व पुनर्वसाहत करताना वाजवी भरपाई मिळण्याचा व पारदर्शकतेचा हक्क अधिनियम,2013 (2013 चा 30) (यात यापुढे ज्याचा निर्देश "उक्त अधिनीयम" असा केला आहे) यांच्या कलम ११ च्या पोट कलम (1) द्वारे प्रदान करण्यात आलेल्या अधिकारांचा वापर क्रमांक, ${getFieldValue('section_11_notification', 'N/A')} दिनांक ${formatDate(getFieldValue('section_11_date', 'N/A'))} अन्वये प्रारंभिक अधिसूचना काढली आहे आणि त्याव्दारे असे अधिसूचित केले आहे की, यासोबत जोडलेल्या "अनुसूची एक" मध्ये अधिक तपशिलवार वर्णन केलेल्या जमीनीची, "अनुसूची दोन" मध्ये अधिक तपशिलवार विनिर्दिष्ट केलेल्या सार्वजनिक प्रयोजनासाठी आवश्यकता आहे किंवा तिची आवश्यकता भासण्याची शक्यता आहे;

आणि ज्याअर्थी, बुलढाणा जिल्हयाच्या जिल्हाधिकाऱ्याने, कलम 15 च्या पोटकलम (2) अन्वये दिलेला अहवाल, कोणताही असल्यास, विचारात घेतल्यानंतर, उक्त सार्वजनिक प्रयोजनासाठी उक्त जमीन संपादित करण्याची आवश्यकता आहे याबाबत त्याची खात्री पटली आहे आणि म्हणून, उक्त अधिनियमाच्या कलम 19 च्या पोटकलम (1) च्या तरतुदीन्वये, उक्त सार्वजनिक प्रयोजनासाठी उक्त जमीनीची आवश्यकता आहे असे याव्दारे घोषीत करण्यात येत आहे;

आणि ज्याअर्थी, अनुसूची तीन मध्ये अधिक तपशिलवार वर्णन केलेले क्षेत्र हे बाधित कुटुंबियांच्या पुनर्वसन व पुनर्वसाहतीच्या प्रयोजनासाठी "पुनर्वसाहत क्षेत्र म्हणून निर्धारीत केले असल्याचे याव्दारे घोषित केले जात असून, पुनर्वसन व पुनर्वसाहत योजनेचा सारांश "अनुसूची चार" मध्ये विनीर्दिष्ट केला आहे;

आणि ज्याअर्थी, उक्त अधिनियमाच्या कलम 3 च्या खंड (छ) अन्वये, समुचित शासन असलेला जिल्हाधिकारी, उक्त अधिनियमान्वये जिल्हाधिकाऱ्यांची कार्ये पार पाडण्यासाठी उपजिल्हाधिकारी, ${getFieldValue('section_19_branch_name', 'section_11_branch_name', '')}, ${getFieldValue('section_19_office_name', 'section_11_branch_name', '')} यास पदनिर्देशित करीत आहे.`;
  };

  const getDefaultTip = () => {
    return `उक्त जमीनीचे नकाशे, कागदपत्रे उपजिल्हाधिकारी ${getFieldValue('section_19_branch_name', 'section_11_branch_name', '')}, ${getFieldValue('section_19_office_name', 'section_11_branch_name', '')} यांचे कार्यालयामध्ये निरीक्षण करता येईल.`
  };

  // UPDATED: Section 1 content function for display
  const getSection1Content = () => {
    const userContent = formData.section_19_content;

    if (
      userContent &&
      typeof userContent === "string" &&
      userContent.trim() !== "" &&
      userContent !== "N/A" &&
      userContent !== "null" &&
      userContent !== "undefined" &&
      userContent.trim() !== getDefaultSection1Content().trim()
    ) {
      return userContent.replace(/\\n/g, "\n");
    }

    // Always return string
    return getDefaultSection1Content() || "";
  };

  // UPDATED:  function for display
  const getTip = () => {

    // Check if we have valid content in formData.section_19_tip
    const userContent = formData.section_19_tip;

    if (userContent &&
      userContent.trim() !== '' &&
      userContent !== 'N/A' &&
      userContent !== 'null' &&
      userContent !== 'undefined' &&
      userContent.trim() !== getDefaultTip().trim()) {
      // Replace \n with actual line breaks for display
      return userContent.replace(/\\n/g, '\n');
    }

    // Return default content
    return getDefaultTip();
  };

  // UPDATED: Section 1 content function for edit modal
  const getSection1ContentForEdit = () => {
    // Always show the current value from formData
    if (formData.section_19_content &&
      formData.section_19_content.trim() !== '' &&
      formData.section_19_content !== 'N/A' &&
      formData.section_19_content !== 'null' &&
      formData.section_19_content !== 'undefined') {
      return formData.section_19_content.replace(/\\n/g, '\n');
    }

    // Otherwise show default content in the edit field
    return getDefaultSection1Content();
  };

  // UPDATED: Section 1 content function for edit modal
  const getTipForEdit = () => {
    // Always show the current value from formData
    if (formData.section_19_tip &&
      formData.section_19_tip.trim() !== '' &&
      formData.section_19_tip !== 'N/A' &&
      formData.section_19_tip !== 'null' &&
      formData.section_19_tip !== 'undefined') {
      return formData.section_19_tip.replace(/\\n/g, '\n');
    }

    // Otherwise show default content in the edit field
    return getDefaultTip();
  };

  const renderNotificationDocument = (ref) => (
    <div
      ref={ref} id="notification-content"
      className="space-y-4 m-1 p-1 bg-white shadow-lg rounded-lg border border-gray-300"
      style={{
        fontFamily: "'Noto Sans Devanagari', Arial, sans-serif",
        minHeight: '297mm',
        width: '210mm',
        padding: '15mm',
        margin: '0 auto'
      }}>

      {/* Header */}
      <div className="text-center mb-5">
        {/* Logo */}
        <img
          src="/Emblem_of_India.svg"
          alt="महाराष्ट्र शासन"
          className="mx-auto mb-2 w-20"
        />

        {/* Government name */}
        <div className="font-bold text-base">महाराष्ट्र शासन</div>
        <div className="font-bold text-base">महसूल व वन विभाग</div>

        {/* Office Name */}
        <div className="font-bold text-2xl font-semibold">
          {getFieldValue('section_19_office_name', 'section_11_office_name', '')}
        </div>

        {/* Branch */}
        <div className="font-medium text-sm font-semibold">
          शाखा :- {getFieldValue('section_19_branch_name', 'section_11_branch_name', '')}
        </div>

        {/* Address */}
        <div className="text-sm font-semibold">
          {getFieldValue('section_19_address', 'section_11_address', '')}
        </div>

      </div>

      {/* Bottom Contact Section */}
      <div className="text-xs mt-4">
        {/* First row: Email + Kramank */}
        <div className="flex justify-between">
          <div>
            ई-मेल :- <span className="font-bold text-black-700">{getFieldValue('section_19_email', 'section_11_email')}</span>
          </div>
          <div>
            दूरध्वनी क्रमांक :- {getFieldValue('section_19_mobile_no', 'section_11_mobile_no', '')}
            {/* क्रमांक :- {getFieldValue('kramank_no', '')} */}
          </div>
        </div>

        {/* Horizontal line */}
        <hr className="border-black border-2 my-1" />

        {/* Second row: Reference no + Date */}
        <div className="flex justify-between">
          <div>
            {getFieldValue('section_19_notification', 'section_11_notification', '')}
          </div>
          <div>
            दिनांक :- {formatDate(getFieldValue('section_19_date', 'section_11_date'))}
          </div>
        </div>
      </div>

      {/* <div className="text-right mb-4 text-sm">
        <div>क्र.का/म.स/उजि/भूसं/{getFieldValue('acquisition_proposal_no', 'N/A')}</div>
        <div>उपजिल्हाधिकारी भूसंपादन, मध्यम प्रकल्प,</div>
        <div>{groupedData && groupedData.length > 0
          ? [...new Set(groupedData.map(item => item.dist))].join(', ')
          : 'N/A'} दिनांक {formatDate(getFieldValue('acquisition_proposal_date', 'N/A'))}</div>
      </div> */}

      <p className="text-center text-base font-bold underline">भूमिसंपादन, पुनर्वसन व पुनर्वसाहत करताना उचित भरपाई मिळण्याचा व पारदर्शकतेचा हक्क अधिनियम – 2013</p>
      <p className="text-center text-base font-bold underline">अन्वये कलम 19 (1) खालील घोषणा</p>
      {/* <p className="text-center text-xl font-bold underline">कलम 19 ची अधिसूचना</p> */}

      <div className="text-justify leading-relaxed space-y-1 text-xs">
        <div class="text-center">
          भूसंपादन प्रकरण क्रमांक :- {getFieldValue('section_19_bhusampadan_no', 'N/A')}
        </div>
        <div className="space-y-4">
          {getSection1Content().split('\n\n').map((paragraph, index) => (
            <p key={index} className="indent-8">
              {paragraph.trim()}
            </p>
          ))}
        </div>

        {/* <div style={{ pageBreakAfter: 'always' }} /> */}

        <div className="mt-8">
          <div className="text-center font-bold underline mt-10 mb-2 text-base">अनुसूची - एक</div>
          {renderAnusuchiOneTable()}
        </div>

        <div className="mt-8">
          <div className="text-center font-bold underline mt-10 mb-2 text-base">अनुसूची - दोन</div>
          <div className="font-bold mb-2 text-sm text-center">सार्वजनिक प्रयोजनाच्या स्वरुपाबाबत विवरण</div>
          <div><b>प्रकल्प नाव :-</b> {getFieldValue('project_name', 'N/A')}</div>
          <div><b>प्रकल्पाच्या कामाचे वर्णन :- </b>{getFieldValue('project_description', 'N/A')}</div>
          <div className='font-bold'>प्रकल्पाचे समाजाला होणारे लाभ :-</div>
          <div>{getFieldValue('project_social_benfit', 'N/A')}</div>
        </div>

        <div className="mt-8">
          <div className="text-center font-bold underline mt-10 mb-2 text-base">अनुसूची - तीन</div>
          <div className="font-bold mt-2 text-sm text-center">पुनर्वसाहत क्षेत्राचे वर्णन</div>
          {/* <div>{getFieldValue('displacement_reason', 'N/A')}</div> */}
          {renderAnusuchiThreeTable()}
        </div>

        {/* <div style={{ pageBreakAfter: 'always' }} /> */}

        <div className="mt-8">
          <div className="text-center font-bold underline mt-10 mb-2 text-base">अनुसूची - चार</div>
          <div className="font-bold mb-2 text-sm text-center">(पुनर्वसन व पुनर्वसाहत योजनेचा सारांश)</div>
          <div>{getFieldValue('section_19_rehabilitation_plan_summary', 'N/A')}</div>
        </div>
        <br></br>
        <div className="mt-6">
          <div>टिप :-
            {getTip().split('\n\n').map((paragraph, index) => (
              <p key={index}>
                {paragraph.trim()}
              </p>
            ))}</div>
        </div>

        <div className="page-break-avoid">
          <div className="mt-8">
            <div>दिनांक :- {formatDate(getFieldValue('section_19_date', 'section_11_date'))}</div>
            <div>ठिकाण :- {groupedData && groupedData.length > 0
              ? [...new Set(groupedData.map(item => item.dist))].join(', ')
              : 'N/A'}</div>
          </div>

          <div className="p-12 m-10  flex justify-between items-end">
            <div className="text-center mt-44">
              <div className="font-bold">({laoName || ''})</div>
              <div className="font-bold">{laoDesi || ''}</div>
            </div>

            <div className="text-center mt-44">
              <div className="font-bold">({usersCollector[0]?.full_name || ''})</div>
              <div className="font-bold">{usersCollector[0]?.designation || ''}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderEditModal = () => (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-xl overflow-hidden max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-8">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-gray-800">{translations[language]?.edit}</h2>
            <button
              onClick={() => setIsEditing(false)}
              className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
            >
              ×
            </button>
          </div>

          {/* Read-only fields display */}
          {/* <div className="bg-gradient-to-r from-gray-50 to-gray-100 p-6 rounded-xl mb-8 border-l-4 border-blue-500">
            <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
              प्रकाशन तपशील (Publication Details)
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <div className="bg-white p-4 rounded-lg shadow-sm">
                <span className="block font-medium text-gray-600 text-sm mb-1">Acquisition Proposal No:</span>
                <span className="text-gray-900 font-semibold">{getFieldValue('acquisition_proposal_no', 'Not Set')}</span>
              </div>
              <div className="bg-white p-4 rounded-lg shadow-sm">
                <span className="block font-medium text-gray-600 text-sm mb-1">Publication No:</span>
                <span className="text-gray-900 font-semibold">{getFieldValue('propsal_publication_no', 'Not Set')}</span>
              </div>
              <div className="bg-white p-4 rounded-lg shadow-sm">
                <span className="block font-medium text-gray-600 text-sm mb-1">Publication Date:</span>
                <span className="text-gray-900 font-semibold">{formatDate(getFieldValue('propsal_publication_date', 'Not Set'))}</span>
              </div>
            </div>
          </div> */}

          <form onSubmit={handleSubmit}>
            {/* Proposal Details */}
            <div className="mb-6">
              <div className="flex items-center justify-center mb-6">
                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full">
                  <h2 className="font-bold text-lg">भूसंपादन प्रकरण तपशील</h2>
                </div>
              </div>

              {/* Two-column grid */}
              <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                <div className="group">
                  <label className="block font-semibold text-gray-700 mb-2 text-base">
                    भूसंपादन क्रमांक :
                  </label>
                  <input
                    type="text"
                    name="section_19_bhusampadan_no"
                    value={formData.section_19_bhusampadan_no}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                    placeholder="Enter Bhusampadan No..."
                  />
                </div>

                <div className="group">
                  <label className="block font-semibold text-gray-700 mb-2 text-base">
                    दिनांक :
                  </label>
                  <input
                    type="date"
                    name="section_19_date"
                    value={formatDateForInput(formData.section_19_date)}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                    placeholder="Enter Date..."
                  />
                </div>

                <div className="group">
                  <label className="block font-semibold text-gray-700 mb-2 text-base">
                    दूरध्वनी क्रमांक :
                  </label>
                  <input
                    type="text"
                    name="section_19_mobile_no"
                    value={formData.section_19_mobile_no}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                    placeholder="Enter Mobile No..."
                  />
                </div>

                <div className="group">
                  <label className="block font-semibold text-gray-700 mb-2 text-base">
                    कार्यालयाचे नाव :
                  </label>
                  <input
                    type="text"
                    name="section_19_office_name"
                    value={formData.section_19_office_name}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                    placeholder="Enter Office name..."
                  />
                </div>

                <div className="group">
                  <label className="block font-semibold text-gray-700 mb-2 text-base">
                    शाखेचे नाव :
                  </label>
                  <input
                    type="text"
                    name="section_19_branch_name"
                    value={formData.section_19_branch_name}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                    placeholder="Enter Branch name..."
                  />
                </div>

                <div className="group">
                  <label className="block font-semibold text-gray-700 mb-2 text-base">
                    अधिसूचना क्रमांक :
                  </label>
                  <input
                    type="text"
                    name="section_19_notification"
                    value={formData.section_19_notification}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                    placeholder="Enter Notification no..."
                  />
                </div>
                <div className="group">
                  <label className="block font-semibold text-gray-700 mb-2 text-base">
                    ई-मेल :
                  </label>
                  <input
                    type="text"
                    name="section_19_email"
                    value={formData.section_19_email}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                    placeholder="Enter Email..."
                  />
                </div>
                <div className="group">
                  <label className="block font-semibold text-gray-700 mb-2 text-base">
                    कार्यालयाचा पत्ता व पिनकोड :
                  </label>
                  <input
                    type="text"
                    name="section_19_address"
                    value={formData.section_19_address}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                    placeholder="Enter Address..."
                  />
                </div>
              </div>
            </div>


            {/* Data Entry */}
            {userRole === ROLES.DATA_ENTRY && (
              <div className="group">
                <label className="block font-semibold text-gray-700 mb-2 text-base">
                  कलम 19 जिल्हाधिकारी कार्यालयाकडे पाठविल्याची दिनांक :
                </label>
                <input
                  type="date"
                  name="section_19_backToLAODate"
                  value={formatDateForInput(formData.section_19_backToLAODate)}
                  onChange={handleInputChange}
                  className="mb-5 px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                  placeholder="Enter Date..."
                />
              </div>
            )}

            {/* Section -1 */}
            <div className="mb-6">
              <div className="flex items-center justify-center mb-6">
                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full">
                  <h2 className="font-bold text-lg">भाग - एक</h2>
                </div>
              </div>

              <div className="space-y-6">
                <div className="group">
                  <label className="block font-semibold text-gray-700 mb-2 text-base">
                    तपशील:
                  </label>
                  <textarea
                    name="section_19_content"
                    value={getSection1ContentForEdit()}
                    onChange={handleInputChange}
                    rows={8}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                    placeholder="Enter section content..."
                  />
                  <p className="text-sm text-gray-500 mt-1">
                    {formData.section_19_content &&
                      formData.section_19_content.trim() !== '' &&
                      formData.section_19_content !== 'N/A' &&
                      formData.section_19_content !== 'null' &&
                      formData.section_19_content !== 'undefined' &&
                      formData.section_19_content.trim() !== getDefaultSection1Content().trim()
                      ? 'Using custom content.'
                      : 'Default content is shown. Start typing to use custom content.'}
                  </p>
                </div>
              </div>
            </div>

            {/* अनुसूची -2 */}
            <div className="mb-5">
              <div className="flex items-center justify-center mb-6">
                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full">
                  <h2 className="font-bold text-lg">अनुसूची - दोन</h2>
                </div>
              </div>

              <div className="space-y-6">
                <div className="group">
                  <label className="block font-semibold text-gray-700 mb-2 text-base">
                    प्रकल्प नाव : {formData.project_name || 'Not Set'}
                  </label>
                  {/* <input
                    type="text"
                    name="project_name"
                    value={formData.project_name}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                    placeholder="Enter project name..."
                  /> */}
                </div>

                <div className="group">
                  <label className="block font-semibold text-gray-700 mb-2 text-base">
                    प्रकल्प कार्याचे वर्णन :
                  </label>
                  <textarea
                    name="project_description"
                    value={formData.project_description}
                    onChange={handleInputChange}
                    rows={4}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                    placeholder="Enter project description..."
                  />
                </div>

                <div className="group">
                  <label className="block font-semibold text-gray-700 mb-2 text-base">
                    प्रकल्पाचे समाजाला मिळणारे लाभ :
                  </label>
                  <textarea
                    name="project_social_benfit"
                    value={formData.project_social_benfit}
                    onChange={handleInputChange}
                    rows={4}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                    placeholder="Enter social benefits..."
                  />
                </div>
              </div>
            </div>

            {/* अनुसूची -3 */}
            <div className="mb-5">
              <div className="flex items-center justify-center mb-6">
                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full">
                  <h2 className="font-bold text-lg">अनुसूची - तीन</h2>
                </div>
              </div>

              {/* {renderAnusuchiThreeTable()} */}

              <div>
                <div className="font-bold text-base text-center">पुनर्वसाहत क्षेत्राचे वर्णन</div>

                {/* Add button */}
                <div className="mb-4">
                  <div className="flex justify-end mb-2">
                    <button
                      type="button"
                      onClick={() => handleAddRow()}
                      className="flex items-center gap-1 px-3 py-1 text-white bg-green-600 hover:bg-green-800 rounded-md shadow-md"
                    >
                      Add
                    </button>
                  </div>
                </div>

                {/* Table container */}
                <div className="w-full">
                  {punarvarshanData && punarvarshanData.length > 0 ? (
                    <table className="border border-black border-collapse mb-4 text-base w-full">
                      <thead>
                        <tr className="bg-gray-200">
                          <th className="border border-black p-2 text-center">अनुक्रमांक</th>
                          <th className="border border-black p-2 text-center">भूमापन क्रमांक</th>
                          <th className="border border-black p-2 text-center">संपादित क्षेत्र (हेक्टर)</th>
                          <th className="border border-black p-2 text-center">जिल्हा</th>
                          <th className="border border-black p-2 text-center">तालुका</th>
                          <th className="border border-black p-2 text-center">गाव</th>
                          <th className="border border-black p-2 text-center">कृती</th>
                        </tr>
                      </thead>
                      <tbody>
                        {punarvarshanData.map((record, index) => (
                          <tr key={record.id || index}>
                            <td className="border border-black p-2 text-center">{index + 1}</td>

                            {/* Survey No */}
                            <td className="border border-black p-2 text-center">
                              <input
                                type="text"
                                value={record.survey_no || ""}
                                onChange={(e) =>
                                  handleEditRowChange(record.id, "survey_no", e.target.value)
                                }
                                className="border px-2 py-1 rounded w-full"
                                placeholder={translations[language]?.EnterSurveyNo || "भूमापन क्रमांक प्रविष्ट करा"}
                              />
                            </td>

                            {/* Acquired Area */}
                            <td className="border border-black p-2 text-center">
                              <input
                                type="text"
                                value={record.aquire_area || ""}
                                onChange={(e) =>
                                  handleEditRowChange(record.id, "aquire_area", e.target.value)
                                }
                                className="border px-2 py-1 rounded w-full"
                                placeholder={translations[language]?.EnterAcquiredArea || "संपादित क्षेत्र प्रविष्ट करा"}
                              />
                            </td>

                            {/* District Dropdown */}
                            <td className="border border-black p-2 text-center">
                              <select
                                value={record.dist_name || ""}
                                onChange={(e) => {
                                  handleEditRowChange(record.id, "dist_name", e.target.value);
                                  handleEditRowChange(record.id, "taluka_name", "");
                                  handleEditRowChange(record.id, "village_name", "");
                                }}
                                className="border px-2 py-1 rounded w-full"
                              >
                                <option value="">जिल्हा</option>
                                {districts.map((dist) => (
                                  <option key={dist.dist_no} value={dist.dist_name}>
                                    {dist.dist_name}
                                  </option>
                                ))}
                              </select>
                            </td>

                            {/* Taluka Dropdown */}
                            <td className="border border-black p-2 text-center">
                              <select
                                value={record.taluka_name || ""}
                                onChange={(e) => {
                                  handleEditRowChange(record.id, "taluka_name", e.target.value);
                                  handleEditRowChange(record.id, "village_name", "");
                                }}
                                className="border px-2 py-1 rounded w-full"
                                disabled={!record.dist_name}
                              >
                                <option value="">तालुका</option>
                                {talukas[record.dist_name]?.map((t) => (
                                  <option key={t.taluka_no} value={t.taluka_name}>
                                    {t.taluka_name}
                                  </option>
                                ))}
                              </select>
                            </td>

                            {/* Village Dropdown */}
                            <td className="border border-black p-2 text-center">
                              <select
                                value={record.village_name || ""}
                                onChange={(e) =>
                                  handleEditRowChange(record.id, "village_name", e.target.value)
                                }
                                className="border px-2 py-1 rounded w-full"
                                disabled={!record.taluka_name}
                              >
                                <option value="">गाव</option>
                                {villages[`${record.dist_name}-${record.taluka_name}`]?.map((v) => (
                                  <option key={v.village_id} value={v.village_name}>
                                    {v.village_name}
                                  </option>
                                ))}
                              </select>
                            </td>

                            {/* Delete button */}
                            <td className="border border-black p-2 text-center">
                              <button
                                type="button"
                                onClick={() => handleDeleteRow(record.id, index)}
                                className="text-red-600 hover:text-red-800"
                                title="Delete Row"
                              >
                                <MdDelete size={15} />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <div>
                      <label className="block font-semibold text-gray-700 mb-2">
                        पुनर्वसाहत क्षेत्राची माहिती उपलब्ध नसल्यास येथे तपशील लिहा :
                      </label>
                      <input
                        type="text"
                        name="section_19_punarvarshan"
                        value={formData.section_19_punarvarshan || ""}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                        placeholder="येथे माहिती लिहा..."
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* अनुसूची -4 */}
            <div className="mb-5">
              <div className="flex items-center justify-center mb-6">
                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full">
                  <h2 className="font-bold text-lg">अनुसूची - चार</h2>
                </div>
              </div>

              <div className="group">
                <label className="block font-semibold text-gray-700 mb-2 text-base">
                  पुनर्वसन व पुनर्वसाहत योजनेचा सारांश :
                </label>
                <textarea
                  name="section_19_rehabilitation_plan_summary"
                  value={formData.section_19_rehabilitation_plan_summary}
                  onChange={handleInputChange}
                  rows={4}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                  placeholder="Enter Rehabilitation Plan summary..."
                />
              </div>
            </div>

            {/* Appointed Administrator */}
            {/* <div className="mb-5">
              <div className="flex items-center justify-center mb-6">
                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full">
                  <h2 className="font-bold text-lg">नियुक्त प्रशासक</h2>
                </div>
              </div>

              <div className="group">
                <label className="block font-semibold text-gray-700 mb-2 text-base">
                  नियुक्त केलेल्या प्रशासकाचा तपशील (Appointed Administrator):
                </label>
                <textarea
                  name="appointed_administrator"
                  value={formData.appointed_administrator}
                  onChange={handleInputChange}
                  rows={3}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                  placeholder="Enter administrator details..."
                />
              </div>
            </div> */}
            <div className="mt-4">
              <div className="mt-4 p-4 bg-blue-50 border-l-4 border-blue-500 rounded-md font-medium text-blue-800 text-base">
                नियुक्त केलेल्या प्रशासकाचा तपशील :- निरंक
              </div>

              <div className="mt-5 p-5 bg-orange-50 border-l-4 border-orange-500 rounded-md">
                <div className="text-brown-800 text-sm leading-relaxed">
                  <span className="font-semibold text-orange-700">टिप :-</span>
                  <textarea
                    name="section_19_tip"
                    value={getTipForEdit()}
                    onChange={handleInputChange}
                    rows={2}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                    placeholder="Enter Tip..."
                  />
                  <p className="text-sm text-gray-500 mt-1">
                    {formData.section_19_tip &&
                      formData.section_19_tip.trim() !== '' &&
                      formData.section_19_tip !== 'N/A' &&
                      formData.section_19_tip !== 'null' &&
                      formData.section_19_tip !== 'undefined' &&
                      formData.section_19_tip.trim() !== getDefaultTip().trim()
                      ? 'Using custom Tip.'
                      : 'Default Tip is shown. Start typing to use custom Tip.'}
                  </p>
                </div>
              </div>
            </div>
            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row justify-end space-y-3 sm:space-y-0 sm:space-x-4 pt-3 border-t border-gray-200">
              <button
                type="button"
                onClick={() => setIsEditing(false)}
                className="px-6 py-3 border-2 border-gray-300 text-gray-700 font-semibold rounded-xl hover:bg-gray-50 hover:border-gray-400 transition-all duration-200 transform hover:scale-105"
              >
                {translations[language]?.Cancel}
              </button>
              <button
                type="submit"
                disabled={loading}
                className="px-8 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold rounded-xl hover:from-blue-700 hover:to-indigo-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed transform hover:scale-105 flex items-center justify-center space-x-3 shadow-lg"
              >
                {loading && (
                  <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent"></div>
                )}
                <span>{loading ? translations[language]?.Saving : translations[language]?.CommonSave}</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );

  const fetchProposalData = async () => {
    try {
      const response = await apiService.getProposalPublish(projectId, proposalId);
      if (response.status === 200 && response.data) {
        const data = response.data;
        setProposalData(data);

        // formData with proposalData
        setFormData(prev => ({
          ...prev,
          // Directly take section_19 if exists, else fallback to section_11
          section_19_bhusampadan_no: data.section_19_bhusampadan_no ?? data.section_11_bhusampadan_no ?? '',
          section_19_office_name: data.section_19_office_name ?? data.section_11_office_name ?? '',
          section_19_branch_name: data.section_19_branch_name ?? data.section_11_branch_name ?? '',
          section_19_notification: data.section_19_notification ?? data.section_11_notification ?? '',
          section_19_email: data.section_19_email ?? data.section_11_email ?? '',
          section_19_address: data.section_19_address ?? data.section_11_address ?? '',
          section_19_mobile_no: data.section_19_mobile_no ?? data.section_11_mobile_no ?? '',
          section_19_date: data.section_19_date ?? data.section_11_date ?? ''
        }));

        // view/edit handling
        const hasSection19Data = checkIfDataComplete(data);

        if (hasSection19Data) {
          const section19Data = {
            section19_published_gazette_no: data.section19_published_gazette_no || '',
            section19_published_gazette: data.section19_published_gazette || '',
            section19_published_newspaper1_no: data.section19_published_newspaper1_no || '',
            section19_published_newspaper1: data.section19_published_newspaper1 || '',
            section19_published_newspaper2_no: data.section19_published_newspaper2_no || '',
            section19_published_newspaper2: data.section19_published_newspaper2 || '',
            section19_municipal_authority_no: data.section19_municipal_authority_no || '',
            section19_municipal_authority: data.section19_municipal_authority || '',
            section19_collector_office_no: data.section19_collector_office_no || '',
            section19_collector_office: data.section19_collector_office || '',
            section19_sub_divisional_office_no: data.section19_sub_divisional_office_no || '',
            section19_sub_divisional_office: data.section19_sub_divisional_office || '',
            section19_tehsil_office_no: data.section19_tehsil_office_no || '',
            section19_tehsil_office: data.section19_tehsil_office || '',
            section19_government_notice_board_no: data.section19_government_notice_board_no || '',
            section19_government_notice_board: data.section19_government_notice_board || '',
            section19_gram_sevak_office_no: data.section19_gram_sevak_office_no || '',
            section19_gram_sevak_office: data.section19_gram_sevak_office || '',
            section19_gram_panchayat_office_no: data.section19_gram_panchayat_office_no || '',
            section19_gram_panchayat_office: data.section19_gram_panchayat_office || '',
            section19_rehabilitation_rights_notice_no: data.section19_rehabilitation_rights_notice_no || '',
            section19_rehabilitation_rights_notice: data.section19_rehabilitation_rights_notice || ''
          };

          setPublishData(section19Data);
          setIsViewMode(true);
        } else {
          setIsViewMode(false);
          console.log('No complete section19 data found - showing edit mode');
        }
      } else {
        console.log('No proposal data found');
        setIsViewMode(false);
      }
    } catch (err) {
      console.error('Error fetching proposal data:', err);
      setIsViewMode(false);
      alert('Failed to fetch proposal data');
    } finally {
      setLoading(false);
    }
  };

  // Handle Publish
  const handlePublish = async () => {

    if (!proposalId) {
      alert('Proposal ID not available');
      return;
    }

    setPublishing(true);

    try {
      const formData = new FormData();

      // Use current publishData state for values
      Object.keys(publishData).forEach(key => {
        const value = publishData[key];
        if (value !== '' && value !== null && key !== 'is_exemption_applicable') { // is_exemption_applicable is derived
          formData.append(key, value);
        }
      });

      // Add images (File objects) only if they are newly selected/uploaded
      Object.keys(uploadedImages).forEach(key => {
        if (uploadedImages[key] && uploadedImages[key] instanceof File) {
          formData.append(key, uploadedImages[key]);
        }
      });

      // Log what's being sent (for debugging)
      console.log('FormData contents for Publish:');
      for (let [key, value] of formData.entries()) {
        console.log(key, value);
      }

      const response = await apiService.updateProposalPublish(proposalId, formData);

      if (response.ok || response.status === 200) { // Check for ok or 200 status
        alert(translations[language]?.Section19PublishedSuccessfully);
        allApi();
      } else {
        // Read error message from response if available
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to publish proposal');
      }

    } catch (error) {
      console.error('Error publishing proposal:', error);
      alert(`Failed to publish proposal: ${error.message}`);
    } finally {
      setPublishing(false);
    }
  };

  // Unified function to handle viewing documents (for both modals)
  const handleViewDocument = (urlOrFile) => {
    if (!urlOrFile) return;

    let url;
    let isPdf;

    if (urlOrFile instanceof File) {
      url = URL.createObjectURL(urlOrFile);
      isPdf = urlOrFile.type === 'application/pdf';
    } else { // Assuming it's a URL string from backend
      url = urlOrFile;
      isPdf = urlOrFile.toLowerCase().includes('.pdf');
    }

    setFileUrlToView(url);
    setIsPDFToView(isPdf);
    setShowDocumentViewer(true);
  };

  const closeDocumentViewer = () => {
    setShowDocumentViewer(false);
    // Revoke Object URL if it was created from a File object
    if (fileUrlToView.startsWith('blob:')) {
      URL.revokeObjectURL(fileUrlToView);
    }
    setFileUrlToView('');
    setIsPDFToView(false);
  };

  // Handle image upload
  const handleImageUpload = (imageType, file) => {
    if (!file) return;

    // Store in uploadedImages (will be sent in FormData)
    setUploadedImages(prev => ({
      ...prev,
      [imageType]: file
    }));

    // Also set selectedDocuments for preview within the publish modal
    setSelectedDocuments(prev => ({
      ...prev,
      [imageType]: file
    }));
  };

  const handlePrint = () => {
    const printContents = tableRef.current.innerHTML;
    const win = window.open("", "_blank");
    win.document.write(`
    <html>
      <head>
        <title>कलम 19 खालील घोषणा प्रसिद्धी तपशील</title>
        <link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
        <style>
         .no-print {
              display: none !important;
         }
        </style>
      </head>
      <body class="p-6">
        <div class="text-center mb-4 mt-5">
          <h2 class="font-bold text-lg mb-2">कलम 19 खालील घोषणा प्रसिद्धी तपशील</h2>
          <p class="text-sm">Project : ${projectName} | Proposal : ${proposalData.acquisition_proposal_no}</p>
        </div>
        <div class="overflow-x-auto">
          ${printContents}
        </div>
        <script>
          window.onload = function() {
            window.print();
          }
        </script>
      </body>
    </html>
  `);
    win.document.close();
  };

  // Tracking Button
  // fetch Samanvay users
  const fetchusersSamanvay = async () => {
    setLoadingusersSamanvay(true);
    try {
      const response = await apiService.getAllUserRoleSamanvay();
      console.log('Samanvay users:', response);
      if (response.status === 200 && response.data) {
        setusersSamanvay(Array.isArray(response.data) ? response.data : []);
      } else {
        setusersSamanvay([]);
      }
    } catch (error) {
      console.error('Error fetching Samanvay users:', error);
      setusersSamanvay([]);
    } finally {
      setLoadingusersSamanvay(false);
    }
  };

  // Handle Send to Samanvay
  const handleSendToSamanvay = async () => {
    if (!selectedUserSamanvay || !selectedDocumentSamanvay) {
      alert('Please select a user and upload a document to send to Samanvay Officer.');
      return;
    }

    if (!projectId || !proposalId) {
      alert('Project ID and Proposal ID are required.');
      return;
    }

    setsendingToSamanvay(true);

    try {
      const formData = new FormData();
      formData.append('project_id', projectId);
      formData.append('proposal_id', proposalId);
      formData.append('remarks', remarksSamanvay);
      formData.append('usr_id', selectedUserSamanvay);
      formData.append('document', selectedDocumentSamanvay);

      const response = await apiService.postTrackingSamanvaySection19(formData);
      console.log('Send to Samanvay response:', response);

      if (response.status === 200) {
        alert(
          translations[language]?.SuccessfullySentToSamanvayOfficer
          || "Successfully sent to Samanvay Officer!"
        );
        setshowSendToSamanvayModal(false);
        setselectedUserSamanvay('');
        setremarksSamanvay('Approved');
        setselectedDocumentSamanvay(null);
        fetchButtonStatus();

      } else {
        alert('Failed to send to Samanvay Officer. Please try again.');
      }
    } catch (error) {
      console.error('Error sending to Samanvay:', error);
      alert('Failed to send to Samanvay Officer. Please try again.');
    } finally {
      setsendingToSamanvay(false);
    }
  };

  // fetch Collector users
  const fetchUsersAllCollector = async () => {
    setLoadingusersCollector(true);
    try {
      const response = await apiService.getAllUserCollector();
      console.log('Collector users:', response);
      if (response.status === 200 && response.data) {
        setusersCollectorAll(Array.isArray(response.data) ? response.data : []);
      } else {
        setusersCollectorAll([]);
      }
    } catch (error) {
      console.error('Error fetching Collector users:', error);
      setusersCollectorAll([]);
    } finally {
      setLoadingusersCollector(false);
    }
  };

  // Handle Send to Collector
  const handleSendToCollector = async () => {
    if (!selectedUserCollector || !selectedDocumentCollector) {
      alert('Please select a user and upload a document to send to Collector Officer.');
      return;
    }

    if (!projectId || !proposalId) {
      alert('Project ID and Proposal ID are required.');
      return;
    }

    setsendingToCollector(true);

    try {
      const formData = new FormData();
      formData.append('project_id', projectId);
      formData.append('proposal_id', proposalId);
      formData.append('remarks', remarksCollector);
      formData.append('usr_id', selectedUserCollector);
      formData.append('document', selectedDocumentCollector);

      const response = await apiService.postTrackingCollectorSection19(formData);
      console.log('Send to Collector response:', response);

      if (response.status === 200) {
        alert(
          translations[language]?.SuccessfullySentToCollectorOfficer
          || "Successfully sent to Collector Officer!"
        );
        // alert('Successfully sent to Collector Officer!');
        allApi();
        setshowSendToCollectorModal(false);
        setselectedUserCollector('');
        setremarksCollector('Approved');
        setselectedDocumentCollector(null);
        fetchButtonStatus();

      } else {
        alert('Failed to send to Collector Officer. Please try again.');
      }
    } catch (error) {
      console.error('Error sending to Collector:', error);
      alert('Failed to send to Collector Officer. Please try again.');
    } finally {
      setsendingToCollector(false);
    }
  };

  // fetch LAO users
  const fetchusersLAO = async () => {
    const role = 3;
    setLoadingusersLAO(true);
    try {
      const response = await apiService.getAssignLAO(role, projectId, proposalId);
      console.log('LAO users:', response);
      if (response.status === 200 && response.data) {
        setusersLAO(Array.isArray(response.data) ? response.data : []);
      } else {
        setusersLAO([]);
      }
    } catch (error) {
      console.error('Error fetching LAO users:', error);
      setusersLAO([]);
    } finally {
      setLoadingusersLAO(false);
    }
  };

  // Handle Send to LAO
  const handleSendToLAO = async () => {
    if (!selectedUserLAO || !selectedDocumentLAO) {
      alert('Please select a user and upload a document to send to LAO Officer.');
      return;
    }

    if (!projectId || !proposalId) {
      alert('Project ID and Proposal ID are required.');
      return;
    }

    setsendingToLAO(true);

    try {
      const formData = new FormData();
      formData.append('project_id', projectId);
      formData.append('proposal_id', proposalId);
      formData.append('remarks', remarksLAO);
      formData.append('usr_id', selectedUserLAO);
      formData.append('document', selectedDocumentLAO);

      const response = await apiService.postTrackingLAOPublishSection19(formData);
      console.log('Send to LAO response:', response);

      if (response.status === 200) {
        alert(
          translations[language]?.SuccessfullySentToLAOOfficer
          || "Successfully sent to LAO Officer!"
        );
        // alert('Successfully sent to LAO Officer!');
        await allApi();
        setshowSendToLAOModal(false);
        setselectedUserLAO('');
        setremarksLAO('Approved');
        setselectedDocumentLAO(null);
        fetchButtonStatus();

      } else {
        alert('Failed to send to LAO Officer. Please try again.');
      }
    } catch (error) {
      console.error('Error sending to LAO:', error);
      alert('Failed to send to LAO Officer. Please try again.');
    } finally {
      setsendingToLAO(false);
    }
  };

  // Button Disable
  const fetchButtonStatus = async () => {
    try {
      if (!projectId || !proposalId) return;

      // setLoading(true);
      let response;

      // Edit button disable
      response = await apiService.getfetchLAOPublishSection19Button(projectId, proposalId);
      setCollectorEditCompletedbuttonDisabled(!response.buttonDisable);

      switch (userRole) {
        case ROLES.LAO:
          response = await apiService.getfetchSamanvayButtonSection19(projectId, proposalId);
          break;
        case ROLES.SAMANVAY:
          response = await apiService.getfetchCollectorButtonSection19(projectId, proposalId);
          break;
        case ROLES.COLLECTOR:
          response = await apiService.getfetchLAOPublishSection19Button(projectId, proposalId);
          break;
        default:
          return;
      }
      setButtonDisabled(!response.buttonDisable);
    } catch (error) {
      console.error("Error fetching DSLR button state:", error);
    } finally {
      // setLoading(false); // Only set loading to false for main data fetch
    }
  };

  // ADD THESE HELPER FUNCTIONS HERE:
  const showAlert = (title, message, type = 'info') => {
    setAlertConfig({ title, message, type });
    setShowAlertModal(true);

    // Don't auto-hide success messages so user can see them
    if (type !== 'success') {
      setTimeout(() => setShowAlertModal(false), 5000);
    }
  };

  const showConfirm = (title, message, onConfirm, onCancel = null, type = 'warning') => {
    setConfirmConfig({ title, message, onConfirm, onCancel, type });
    setShowConfirmModal(true);
  };

  return (
    <>
      <div className="bg-gray-50 min-h-screen">
        <div className="max-w-7xl mx-auto p-4">
          {/* Header */}
          <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
            <div className="flex justify-between items-center">
              <div>
                {/* <h1 className="text-2xl font-bold text-gray-900">कलम 19 ची अधिसूचना</h1> */}
                <p className="text-gray-600 mt-1">
                  {/* Project ID: {projectId} | Proposal ID: {proposalId || 'Not Found'} */}
                </p>
              </div>

              {/* Action Buttons */}
              <div className="flex gap-3">
                <button
                  type="button"
                  onClick={handlePrintView}
                  className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors flex items-center space-x-2"
                >
                  <span>{translations[language]?.Print}</span>
                </button>

                {/* {userRole === ROLES.LAO && ( */}
                {/* Data Entry */}
                {(userRole === ROLES.LAO || userRole === ROLES.DATA_ENTRY) && (
                  <button
                    type="button"
                    onClick={() => setIsEditing(true)}
                    disabled={collectorEditCompletedbuttonDisabled}
                    className={`px-6 py-2 rounded-lg flex items-center space-x-2 transition-colors 
                  ${collectorEditCompletedbuttonDisabled
                        ? 'bg-gray-400 text-white cursor-not-allowed'
                        : 'bg-blue-600 text-white hover:bg-blue-700'}`}
                  >
                    <span>{translations[language]?.Edit}</span>
                  </button>
                )}

                {/* {userRole === ROLES.LAO && ( */}
                {/* Data ENtry */}
                {(userRole === ROLES.LAO || userRole === ROLES.DATA_ENTRY) && (
                  <>
                    {/* {collectorEditCompletedbuttonDisabled && ( */}
                    {/* Data Entry */}
                    {(userRole === ROLES.DATA_ENTRY || collectorEditCompletedbuttonDisabled) && (
                      <button
                        onClick={() => setShowPublishModal(true)}
                        disabled={publishing}
                        className={`flex items-center px-4 py-2 rounded-lg transition-colors ${publishing
                          ? 'bg-gray-400 text-gray-200 cursor-not-allowed'
                          : 'bg-blue-700 text-white hover:bg-blue-800'
                          }`}
                        title="Publish the proposal"
                      >
                        <Globe className="mr-2 h-4 w-4" />
                        {translations[language]?.Section19Publication}
                      </button>
                    )}
                  </>
                )}

                {userRole === ROLES.LAO && (
                  <button
                    type="button"
                    onClick={() => {
                      if (buttonDisabled) {
                        showConfirm(
                          translations[language]?.confirmResubmission,
                          translations[language]?.resubmissionWarning,
                          () => {
                            // what should happen on confirm
                            setshowSendToSamanvayModal(true);
                          },
                          () => {
                            // optional cancel callback
                            console.log("Resend cancelled");
                          },
                          "danger" // modal color type
                        );
                      } else {
                        setshowSendToSamanvayModal(true);
                      }
                    }}
                    className={`flex items-center px-4 py-2 rounded-lg transition-colors ${buttonDisabled
                      ? "bg-red-600 text-white hover:bg-red-700"
                      : "bg-purple-600 text-white hover:bg-purple-700"
                      }`}
                    title={
                      buttonDisabled
                        ? translations[language]?.AlreadySentToSamanvayOfficerClickToResend
                        : translations[language]?.SendToSamanvayOfficer
                    }
                  >
                    <Send className="mr-2 h-4 w-4" />
                    <span>{translations[language]?.SendToSamanvayOfficer}</span>
                  </button>
                )}

                {userRole === ROLES.SAMANVAY && (
                  <>
                    <button
                      type="button"
                      onClick={() => {
                        if (buttonDisabled) {
                          showConfirm(
                            translations[language]?.confirmResubmission,
                            translations[language]?.resubmissionWarning,
                            () => {
                              // what should happen on confirm
                              setshowSendToCollectorModal(true);
                            },
                            () => {
                              // optional cancel callback
                              console.log("Resend cancelled");
                            },
                            "danger" // modal color type
                          );
                        } else {
                          setshowSendToCollectorModal(true);
                        }
                      }}
                      className={`flex items-center px-4 py-2 rounded-lg transition-colors ${buttonDisabled
                        ? "bg-red-600 text-white hover:bg-red-700"
                        : "bg-purple-600 text-white hover:bg-purple-700"
                        }`}
                      title={
                        buttonDisabled
                          ? translations[language]?.SendToCollectorAlreadySentClickToResend
                          : translations[language]?.SendToCollector
                      }
                    >
                      <Send className="mr-2 h-4 w-4" />
                      <span>{translations[language]?.SendToCollector}</span>
                    </button>
                  </>
                )}

                {userRole === ROLES.COLLECTOR && (
                  <>
                    <button
                      type="button"
                      onClick={() => {
                        if (buttonDisabled) {
                          showConfirm(
                            translations[language]?.confirmResubmission,
                            translations[language]?.resubmissionWarning,
                            () => {
                              // what should happen on confirm
                              setshowSendToLAOModal(true);
                            },
                            () => {
                              // optional cancel callback
                              console.log("Resend cancelled");
                            },
                            "danger" // modal color type
                          );
                        } else {
                          setshowSendToLAOModal(true);
                        }
                      }}
                      className={`flex items-center px-4 py-2 rounded-lg transition-colors ${buttonDisabled
                        ? "bg-red-600 text-white hover:bg-red-700"
                        : "bg-purple-600 text-white hover:bg-purple-700"
                        }`}
                      title={
                        buttonDisabled
                          ? translations[language]?.AlreadySentBackToLAOClickToResend
                          : translations[language]?.sendToLAO
                      }
                    >
                      <Send className="mr-2 h-4 w-4" />
                      <span>{translations[language]?.sendToLAO}</span>
                    </button>

                  </>
                )}
              </div>
            </div>
          </div>

          {/* Main Document Display */}
          <div>
            {renderNotificationDocument(notificationContentRef)}
          </div>
        </div>
      </div>

      {/* Edit Modal */}
      {isEditing && renderEditModal()}

      {/* Publish Modal */}
      {showPublishModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-5xl mx-4 max-h-[90vh] overflow-y-auto">

            <div className="p-6">
              <div className="flex justify-between items-start mb-6">
                {/* Left side (Title + Subtitle) */}
                <div>
                  <h3 className="text-xl font-semibold text-gray-800">
                    {translations[language]?.Section19Publication}
                  </h3>
                  {/* <p className="text-xs italic text-gray-500 mt-1">
                    through section 19
                  </p> */}
                </div>

                {/* Right side (Actions) */}
                {isViewMode && (
                  <div className="flex items-center gap-3">
                    <button
                      onClick={handlePrint}
                      className="px-4 py-2 bg-green-600 text-white rounded-lg shadow hover:bg-green-700 transition"
                    >
                      {translations[language]?.Print}
                    </button>


                    <button
                      onClick={() => setShowPublishModal(false)}
                      className="text-gray-400 hover:text-gray-600 transition"
                    >
                      <X className="h-6 w-6" />
                    </button>
                  </div>
                )}
              </div>

              <div className="overflow-x-auto" ref={tableRef}>
                <table className="min-w-full table-auto border border-gray-300 shadow rounded-lg text-sm">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="p-3 border text-left font-medium text-gray-700 text-center">{translations[language]?.SrNo}</th>
                      <th className="p-3 border text-left font-medium text-gray-700 text-center">{translations[language]?.OfficeofPublication}</th>
                      <th className="p-3 border text-left font-medium text-gray-700 text-center">{translations[language]?.No}</th>
                      <th className="p-3 border text-left font-medium text-gray-800 text-center">{translations[language]?.DateofPublication}</th>
                      <th className="no-print p-3 border text-left font-medium text-gray-800 text-center">{translations[language]?.Documents}</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {/* Government Gazette No and Date */}
                    <tr>
                      {/* Serial Number */}
                      <td className="p-2 border">1</td>

                      {/* Office of Publication */}
                      <td className="p-2 border">{translations[language]?.GovernmentGazette}</td>

                      {/* Number Column */}
                      <td className="p-2 border">
                        {isViewMode ? (
                          <div className="p-2 bg-gray-50 rounded">
                            {proposalData.section19_published_gazette_no || '-'}
                          </div>
                        ) : (
                          <input
                            type="text"
                            value={publishData.section19_published_gazette_no}
                            onChange={(e) =>
                              setPublishData({
                                ...publishData,
                                section19_published_gazette_no: e.target.value
                              })
                            }
                            placeholder="Enter proceeding number"
                            className="w-full p-2 border rounded"
                          />
                        )}
                      </td>

                      {/* Date Column */}
                      <td className="p-2 border">
                        {isViewMode ? (
                          <div className="p-2 bg-gray-50 rounded">
                            {formatDate(proposalData.section19_published_gazette) || '-'}
                          </div>
                        ) : (
                          <input
                            type="date"
                            value={publishData.section19_published_gazette}
                            onChange={(e) =>
                              setPublishData({
                                ...publishData,
                                section19_published_gazette: e.target.value
                              })
                            }
                            className="w-full p-2 border rounded"
                          />
                        )}
                      </td>

                      {/* Document Column */}
                      <td className="no-print p-2 border">
                        {isViewMode ? (
                          // View Mode: Show view button if document exists, otherwise show "No document"
                          selectedDocuments['section19_published_gazette_img'] ||
                            proposalData.section19_published_gazette_img ? (
                            <button
                              type="button"
                              onClick={() => handleViewDocument(proposalData.section19_published_gazette_img)}
                              className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                            >
                              <Eye className="h-3 w-3" />
                              {translations[language]?.View}
                            </button>
                          ) : (
                            <span className="text-gray-500 text-xs">No document</span>
                          )
                        ) : (
                          // Edit Mode: Show file input and selected file preview
                          <>
                            <input
                              type="file"
                              accept="image/*,.pdf"
                              onChange={(e) =>
                                handleImageUpload('section19_published_gazette_img', e.target.files[0])
                              }
                              className="w-full p-2 border rounded text-xs"
                            />
                            {selectedDocuments['section19_published_gazette_img'] && (
                              <div className="mt-2 flex items-center justify-between p-2 bg-green-50 rounded-lg">
                                <p className="text-xs text-green-600 truncate max-w-[70%]">
                                  {translations[language]?.Selected}: {' '}
                                  {selectedDocuments['section19_published_gazette_img'].name}
                                </p>
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleViewDocument(selectedDocuments['section19_published_gazette_img'])
                                  }
                                  className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                                >
                                  <Eye className="h-3 w-3" />
                                  {translations[language]?.View}
                                </button>
                              </div>
                            )}
                          </>
                        )}
                      </td>
                    </tr>

                    {/* Newspaper - 1 No and Date */}
                    <tr>
                      <td className="p-2 border">2</td>
                      <td className="p-2 border">{translations[language]?.Newspaper1}</td>

                      {/* Order Number Column */}
                      <td className="p-2 border">
                        {isViewMode ? (
                          <div className="p-2 bg-gray-50 rounded">
                            {proposalData.section19_published_newspaper1_no || '-'}
                          </div>
                        ) : (
                          <input
                            type="text"
                            value={publishData.section19_published_newspaper1_no}
                            onChange={(e) =>
                              setPublishData({ ...publishData, section19_published_newspaper1_no: e.target.value })
                            }
                            placeholder="Enter administrative order number"
                            className="w-full p-2 border rounded"
                          />
                        )}
                      </td>

                      {/* Date Column */}
                      <td className="p-2 border">
                        {isViewMode ? (
                          <div className="p-2 bg-gray-50 rounded">
                            {formatDate(proposalData.section19_published_newspaper1) || '-'}
                          </div>
                        ) : (
                          <input
                            type="date"
                            value={publishData.section19_published_newspaper1}
                            onChange={(e) =>
                              setPublishData({ ...publishData, section19_published_newspaper1: e.target.value })
                            }
                            className="w-full p-2 border rounded"
                          />
                        )}
                      </td>

                      {/* Document Column */}
                      <td className="no-print p-2 border">
                        {isViewMode ? (
                          selectedDocuments['section19_published_newspaper1_img'] ||
                            proposalData.section19_published_newspaper1_img ? (
                            <button
                              type="button"
                              onClick={() => handleViewDocument(proposalData.section19_published_newspaper1_img)}
                              className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                            >
                              <Eye className="h-3 w-3" /> {translations[language]?.View}
                            </button>
                          ) : (
                            <span className="text-gray-500 text-xs">No document</span>
                          )
                        ) : (
                          <>
                            <input
                              type="file"
                              accept="image/*,.pdf"
                              onChange={(e) =>
                                handleImageUpload('section19_published_newspaper1_img', e.target.files[0])
                              }
                              className="w-full p-2 border rounded text-xs"
                            />
                            {selectedDocuments['section19_published_newspaper1_img'] && (
                              <div className="mt-2 flex items-center justify-between p-2 bg-green-50 rounded-lg">
                                <p className="text-xs text-green-600 truncate max-w-[70%]">
                                  {translations[language]?.Selected}:{' '}
                                  {selectedDocuments['section19_published_newspaper1_img'].name}
                                </p>
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleViewDocument(selectedDocuments['section19_published_newspaper1_img'])
                                  }
                                  className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                                >
                                  <Eye className="h-3 w-3" /> {translations[language]?.View}
                                </button>
                              </div>
                            )}
                          </>
                        )}
                      </td>
                    </tr>

                    {/* Newspaper - 2 No and Date */}
                    <tr>
                      <td className="p-2 border">3</td>
                      <td className="p-2 border">{translations[language]?.Newspaper2}</td>

                      {/* Publication Number Column */}
                      <td className="p-2 border">
                        {isViewMode ? (
                          <div className="p-2 bg-gray-50 rounded">
                            {proposalData.section19_published_newspaper2_no || '-'}
                          </div>
                        ) : (
                          <input
                            type="text"
                            value={publishData.section19_published_newspaper2_no}
                            onChange={(e) =>
                              setPublishData({
                                ...publishData,
                                section19_published_newspaper2_no: e.target.value,
                              })
                            }
                            placeholder="Enter publication number"
                            className="w-full p-2 border rounded"
                          />
                        )}
                      </td>

                      {/* Date Column */}
                      <td className="p-2 border">
                        {isViewMode ? (
                          <div className="p-2 bg-gray-50 rounded">
                            {formatDate(proposalData.section19_published_newspaper2) || '-'}
                          </div>
                        ) : (
                          <input
                            type="date"
                            value={publishData.section19_published_newspaper2}
                            onChange={(e) =>
                              setPublishData({
                                ...publishData,
                                section19_published_newspaper2: e.target.value,
                              })
                            }
                            className="w-full p-2 border rounded"
                          />
                        )}
                      </td>

                      {/* Document Column */}
                      <td className="no-print p-2 border">
                        {isViewMode ? (
                          selectedDocuments['section19_published_newspaper2_img'] ||
                            proposalData.section19_published_newspaper2_img ? (
                            <button
                              type="button"
                              onClick={() => handleViewDocument(proposalData.section19_published_newspaper2_img)}
                              className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                            >
                              <Eye className="h-3 w-3" /> {translations[language]?.View}
                            </button>
                          ) : (
                            <span className="text-gray-500 text-xs">No document</span>
                          )
                        ) : (
                          <>
                            <input
                              type="file"
                              accept="image/*,.pdf"
                              onChange={(e) =>
                                handleImageUpload(
                                  'section19_published_newspaper2_img',
                                  e.target.files[0]
                                )
                              }
                              className="w-full p-2 border rounded text-xs"
                            />
                            {selectedDocuments['section19_published_newspaper2_img'] && (
                              <div className="mt-2 flex items-center justify-between p-2 bg-green-50 rounded-lg">
                                <p className="text-xs text-green-600 truncate max-w-[70%]">
                                  {translations[language]?.Selected}:{' '}
                                  {selectedDocuments['section19_published_newspaper2_img'].name}
                                </p>
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleViewDocument(
                                      selectedDocuments['section19_published_newspaper2_img']
                                    )
                                  }
                                  className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                                >
                                  <Eye className="h-3 w-3" /> {translations[language]?.View}
                                </button>
                              </div>
                            )}
                          </>
                        )}
                      </td>
                    </tr>

                    {/* Municipal Corporation No and Date */}
                    <tr>
                      <td className="p-2 border">4</td>
                      <td className="p-2 border">{translations[language]?.MunicipalCorporation}</td>

                      {/* Number Column */}
                      <td className="p-2 border">
                        {isViewMode ? (
                          <div className="p-2 bg-gray-50 rounded">
                            {proposalData.section19_municipal_authority_no || '-'}
                          </div>
                        ) : (
                          <input
                            type="text"
                            value={publishData.section19_municipal_authority_no}
                            onChange={(e) =>
                              setPublishData({
                                ...publishData,
                                section19_municipal_authority_no: e.target.value,
                              })
                            }
                            placeholder="Enter Municipal Corporation number"
                            className="w-full p-2 border rounded"
                          />
                        )}
                      </td>

                      {/* Date Column */}
                      <td className="p-2 border">
                        {isViewMode ? (
                          <div className="p-2 bg-gray-50 rounded">
                            {formatDate(proposalData.section19_municipal_authority) || '-'}
                          </div>
                        ) : (
                          <input
                            type="date"
                            value={publishData.section19_municipal_authority}
                            onChange={(e) =>
                              setPublishData({
                                ...publishData,
                                section19_municipal_authority: e.target.value,
                              })
                            }
                            className="w-full p-2 border rounded"
                          />
                        )}
                      </td>

                      {/* Document Column */}
                      <td className="no-print p-2 border">
                        {isViewMode ? (
                          selectedDocuments['section19_municipal_authority_img'] ||
                            proposalData.section19_municipal_authority_img ? (
                            <button
                              type="button"
                              onClick={() => handleViewDocument(proposalData.section19_municipal_authority_img)}
                              className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                            >
                              <Eye className="h-3 w-3" /> {translations[language]?.View}
                            </button>
                          ) : (
                            <span className="text-gray-500 text-xs">No document</span>
                          )
                        ) : (
                          <>
                            <input
                              type="file"
                              accept="image/*,.pdf"
                              onChange={(e) =>
                                handleImageUpload(
                                  'section19_municipal_authority_img',
                                  e.target.files[0]
                                )
                              }
                              className="w-full p-2 border rounded text-xs"
                            />
                            {selectedDocuments['section19_municipal_authority_img'] && (
                              <div className="mt-2 flex items-center justify-between p-2 bg-green-50 rounded-lg">
                                <p className="text-xs text-green-600 truncate max-w-[70%]">
                                  {translations[language]?.Selected}:{' '}
                                  {selectedDocuments['section19_municipal_authority_img'].name}
                                </p>
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleViewDocument(
                                      selectedDocuments['section19_municipal_authority_img']
                                    )
                                  }
                                  className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                                >
                                  <Eye className="h-3 w-3" /> {translations[language]?.View}
                                </button>
                              </div>
                            )}
                          </>
                        )}
                      </td>
                    </tr>

                    {/* District Collector Office No and Date */}
                    <tr>
                      <td className="p-2 border">5</td>
                      <td className="p-2 border">{translations[language]?.DistrictCollectorOffice}</td>

                      {/* Number Column */}
                      <td className="p-2 border">
                        {isViewMode ? (
                          <div className="p-2 bg-gray-50 rounded">
                            {proposalData.section19_collector_office_no || '-'}
                          </div>
                        ) : (
                          <input
                            type="text"
                            value={publishData.section19_collector_office_no}
                            onChange={(e) =>
                              setPublishData({
                                ...publishData,
                                section19_collector_office_no: e.target.value,
                              })
                            }
                            placeholder="Enter District Collector Office number"
                            className="w-full p-2 border rounded"
                          />
                        )}
                      </td>

                      {/* Date Column */}
                      <td className="p-2 border">
                        {isViewMode ? (
                          <div className="p-2 bg-gray-50 rounded">
                            {formatDate(proposalData.section19_collector_office) || '-'}
                          </div>
                        ) : (
                          <input
                            type="date"
                            value={publishData.section19_collector_office}
                            onChange={(e) =>
                              setPublishData({
                                ...publishData,
                                section19_collector_office: e.target.value,
                              })
                            }
                            className="w-full p-2 border rounded"
                          />
                        )}
                      </td>

                      {/* Document Column */}
                      <td className="no-print p-2 border">
                        {isViewMode ? (
                          selectedDocuments['section19_collector_office_img'] ||
                            proposalData.section19_collector_office_img ? (
                            <button
                              type="button"
                              onClick={() => handleViewDocument(proposalData.section19_collector_office_img)}
                              className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                            >
                              <Eye className="h-3 w-3" /> {translations[language]?.View}
                            </button>
                          ) : (
                            <span className="text-gray-500 text-xs">No document</span>
                          )
                        ) : (
                          <>
                            <input
                              type="file"
                              accept="image/*,.pdf"
                              onChange={(e) =>
                                handleImageUpload(
                                  'section19_collector_office_img',
                                  e.target.files[0]
                                )
                              }
                              className="w-full p-2 border rounded text-xs"
                            />
                            {selectedDocuments['section19_collector_office_img'] && (
                              <div className="mt-2 flex items-center justify-between p-2 bg-green-50 rounded-lg">
                                <p className="text-xs text-green-600 truncate max-w-[70%]">
                                  {translations[language]?.Selected}:{' '}
                                  {selectedDocuments['section19_collector_office_img'].name}
                                </p>
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleViewDocument(
                                      selectedDocuments['section19_collector_office_img']
                                    )
                                  }
                                  className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                                >
                                  <Eye className="h-3 w-3" /> {translations[language]?.View}
                                </button>
                              </div>
                            )}
                          </>
                        )}
                      </td>
                    </tr>

                    {/* Sub-Divisional Officer No and Date */}
                    <tr>
                      <td className="p-2 border">6</td>
                      <td className="p-2 border">{translations[language]?.SubDivisionalOfficer}</td>

                      {/* Number Column */}
                      <td className="p-2 border">
                        {isViewMode ? (
                          <div className="p-2 bg-gray-50 rounded">
                            {proposalData.section19_sub_divisional_office_no || '-'}
                          </div>
                        ) : (
                          <input
                            type="text"
                            value={publishData.section19_sub_divisional_office_no}
                            onChange={(e) =>
                              setPublishData({
                                ...publishData,
                                section19_sub_divisional_office_no: e.target.value,
                              })
                            }
                            placeholder="Enter Sub-Divisional Officer number"
                            className="w-full p-2 border rounded"
                          />
                        )}
                      </td>

                      {/* Date Column */}
                      <td className="p-2 border">
                        {isViewMode ? (
                          <div className="p-2 bg-gray-50 rounded">
                            {formatDate(proposalData.section19_sub_divisional_office) || '-'}
                          </div>
                        ) : (
                          <input
                            type="date"
                            value={publishData.section19_sub_divisional_office}
                            onChange={(e) =>
                              setPublishData({
                                ...publishData,
                                section19_sub_divisional_office: e.target.value,
                              })
                            }
                            className="w-full p-2 border rounded"
                          />
                        )}
                      </td>

                      {/* Document Column */}
                      <td className="no-print p-2 border">
                        {isViewMode ? (
                          selectedDocuments['section19_sub_divisional_office_img'] ||
                            proposalData.section19_sub_divisional_office_img ? (
                            <button
                              type="button"
                              onClick={() => handleViewDocument(proposalData.section19_sub_divisional_office_img)}
                              className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                            >
                              <Eye className="h-3 w-3" /> {translations[language]?.View}
                            </button>
                          ) : (
                            <span className="text-gray-500 text-xs">No document</span>
                          )
                        ) : (
                          <>
                            <input
                              type="file"
                              accept="image/*,.pdf"
                              onChange={(e) =>
                                handleImageUpload(
                                  'section19_sub_divisional_office_img',
                                  e.target.files[0]
                                )
                              }
                              className="w-full p-2 border rounded text-xs"
                            />
                            {selectedDocuments['section19_sub_divisional_office_img'] && (
                              <div className="mt-2 flex items-center justify-between p-2 bg-green-50 rounded-lg">
                                <p className="text-xs text-green-600 truncate max-w-[70%]">
                                  {translations[language]?.Selected}:{' '}
                                  {selectedDocuments['section19_sub_divisional_office_img'].name}
                                </p>
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleViewDocument(
                                      selectedDocuments['section19_sub_divisional_office_img']
                                    )
                                  }
                                  className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                                >
                                  <Eye className="h-3 w-3" /> {translations[language]?.View}
                                </button>
                              </div>
                            )}
                          </>
                        )}
                      </td>
                    </tr>

                    {/* Tehsil Office No and Date */}
                    <tr>
                      <td className="p-2 border">7</td>
                      <td className="p-2 border">{translations[language].TehsilOffice}</td>

                      {/* Number Column */}
                      <td className="p-2 border">
                        {isViewMode ? (
                          <div className="p-2 bg-gray-50 rounded">
                            {proposalData.section19_tehsil_office_no || '-'}
                          </div>
                        ) : (
                          <input
                            type="text"
                            value={publishData.section19_tehsil_office_no}
                            onChange={(e) =>
                              setPublishData({ ...publishData, section19_tehsil_office_no: e.target.value })
                            }
                            placeholder="Enter Tehsil Office number"
                            className="w-full p-2 border rounded"
                          />
                        )}
                      </td>

                      {/* Date Column */}
                      <td className="p-2 border">
                        {isViewMode ? (
                          <div className="p-2 bg-gray-50 rounded">
                            {formatDate(proposalData.section19_tehsil_office) || '-'}
                          </div>
                        ) : (
                          <input
                            type="date"
                            value={publishData.section19_tehsil_office}
                            onChange={(e) =>
                              setPublishData({ ...publishData, section19_tehsil_office: e.target.value })
                            }
                            className="w-full p-2 border rounded"
                          />
                        )}
                      </td>

                      {/* Document Column */}
                      <td className="no-print p-2 border">
                        {isViewMode ? (
                          selectedDocuments['section19_tehsil_office_img'] ||
                            proposalData.section19_tehsil_office_img ? (
                            <button
                              type="button"
                              onClick={() => handleViewDocument(proposalData.section19_tehsil_office_img)}
                              className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                            >
                              <Eye className="h-3 w-3" /> {translations[language].View}
                            </button>
                          ) : (
                            <span className="text-gray-500 text-xs">No document</span>
                          )
                        ) : (
                          <>
                            <input
                              type="file"
                              accept="image/*,.pdf"
                              onChange={(e) =>
                                handleImageUpload('section19_tehsil_office_img', e.target.files[0])
                              }
                              className="w-full p-2 border rounded text-xs"
                            />
                            {selectedDocuments['section19_tehsil_office_img'] && (
                              <div className="mt-2 flex items-center justify-between p-2 bg-green-50 rounded-lg">
                                <p className="text-xs text-green-600 truncate max-w-[70%]">
                                  {translations[language]?.Selected}:{' '}
                                  {selectedDocuments['section19_tehsil_office_img'].name}
                                </p>
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleViewDocument(selectedDocuments['section19_tehsil_office_img'])
                                  }
                                  className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                                >
                                  <Eye className="h-3 w-3" /> {translations[language].View}
                                </button>
                              </div>
                            )}
                          </>
                        )}
                      </td>
                    </tr>

                    {/* Government Notice Board No and Date */}
                    <tr>
                      <td className="p-2 border">8</td>
                      <td className="p-2 border">{translations[language].GovernmentNoticeBoard}</td>

                      {/* Number Column */}
                      <td className="p-2 border">
                        {isViewMode ? (
                          <div className="p-2 bg-gray-50 rounded">
                            {proposalData.section19_government_notice_board_no || '-'}
                          </div>
                        ) : (
                          <input
                            type="text"
                            value={publishData.section19_government_notice_board_no}
                            onChange={(e) =>
                              setPublishData({
                                ...publishData,
                                section19_government_notice_board_no: e.target.value,
                              })
                            }
                            placeholder="Enter Government Notice Board number"
                            className="w-full p-2 border rounded"
                          />
                        )}
                      </td>

                      {/* Date Column */}
                      <td className="p-2 border">
                        {isViewMode ? (
                          <div className="p-2 bg-gray-50 rounded">
                            {formatDate(proposalData.section19_government_notice_board) || '-'}
                          </div>
                        ) : (
                          <input
                            type="date"
                            value={publishData.section19_government_notice_board}
                            onChange={(e) =>
                              setPublishData({
                                ...publishData,
                                section19_government_notice_board: e.target.value,
                              })
                            }
                            className="w-full p-2 border rounded"
                          />
                        )}
                      </td>

                      {/* Document Column */}
                      <td className="no-print p-2 border">
                        {isViewMode ? (
                          selectedDocuments['section19_government_notice_board_img'] ||
                            proposalData.section19_government_notice_board_img ? (
                            <button
                              type="button"
                              onClick={() => handleViewDocument(proposalData.section19_government_notice_board_img)}
                              className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                            >
                              <Eye className="h-3 w-3" /> {translations[language].View}
                            </button>
                          ) : (
                            <span className="text-gray-500 text-xs">No document</span>
                          )
                        ) : (
                          <>
                            <input
                              type="file"
                              accept="image/*,.pdf"
                              onChange={(e) =>
                                handleImageUpload('section19_government_notice_board_img', e.target.files[0])
                              }
                              className="w-full p-2 border rounded text-xs"
                            />
                            {selectedDocuments['section19_government_notice_board_img'] && (
                              <div className="mt-2 flex items-center justify-between p-2 bg-green-50 rounded-lg">
                                <p className="text-xs text-green-600 truncate max-w-[70%]">
                                  {translations[language]?.Selected}:{' '}
                                  {selectedDocuments['section19_government_notice_board_img'].name}
                                </p>
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleViewDocument(selectedDocuments['section19_government_notice_board_img'])
                                  }
                                  className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                                >
                                  <Eye className="h-3 w-3" /> {translations[language].View}
                                </button>
                              </div>
                            )}
                          </>
                        )}
                      </td>
                    </tr>

                    {/* Gram Sevak Office No and Date */}
                    <tr>
                      <td className="p-2 border">9</td>
                      <td className="p-2 border">{translations[language].GramSevakOffice1}</td>

                      {/* Number Column */}
                      <td className="p-2 border">
                        {isViewMode ? (
                          <div className="p-2 bg-gray-50 rounded">
                            {proposalData.section19_gram_sevak_office_no || '-'}
                          </div>
                        ) : (
                          <input
                            type="text"
                            value={publishData.section19_gram_sevak_office_no}
                            onChange={(e) =>
                              setPublishData({
                                ...publishData,
                                section19_gram_sevak_office_no: e.target.value,
                              })
                            }
                            placeholder="Enter Gram Sevak Office number"
                            className="w-full p-2 border rounded"
                          />
                        )}
                      </td>

                      {/* Date Column */}
                      <td className="p-2 border">
                        {isViewMode ? (
                          <div className="p-2 bg-gray-50 rounded">
                            {formatDate(proposalData.section19_gram_sevak_office) || '-'}
                          </div>
                        ) : (
                          <input
                            type="date"
                            value={publishData.section19_gram_sevak_office}
                            onChange={(e) =>
                              setPublishData({
                                ...publishData,
                                section19_gram_sevak_office: e.target.value,
                              })
                            }
                            className="w-full p-2 border rounded"
                          />
                        )}
                      </td>

                      {/* Document Column */}
                      <td className="no-print p-2 border">
                        {isViewMode ? (
                          selectedDocuments['section19_gram_sevak_office_img'] ||
                            proposalData.section19_gram_sevak_office_img ? (
                            <button
                              type="button"
                              onClick={() => handleViewDocument(proposalData.section19_gram_sevak_office_img)}
                              className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                            >
                              <Eye className="h-3 w-3" /> {translations[language].View}
                            </button>
                          ) : (
                            <span className="text-gray-500 text-xs">No document</span>
                          )
                        ) : (
                          <>
                            <input
                              type="file"
                              accept="image/*,.pdf"
                              onChange={(e) =>
                                handleImageUpload('section19_gram_sevak_office_img', e.target.files[0])
                              }
                              className="w-full p-2 border rounded text-xs"
                            />
                            {selectedDocuments['section19_gram_sevak_office_img'] && (
                              <div className="mt-2 flex items-center justify-between p-2 bg-green-50 rounded-lg">
                                <p className="text-xs text-green-600 truncate max-w-[70%]">
                                  {translations[language]?.Selected}:{' '}
                                  {selectedDocuments['section19_gram_sevak_office_img'].name}
                                </p>
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleViewDocument(selectedDocuments['section19_gram_sevak_office_img'])
                                  }
                                  className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                                >
                                  <Eye className="h-3 w-3" /> {translations[language].View}
                                </button>
                              </div>
                            )}
                          </>
                        )}
                      </td>
                    </tr>

                    {/* Gram Panchayat Office No and Date */}
                    {/* <tr> */}
                    {/* <td className="p-2 border">10</td>
                      <td className="p-2 border">{translations[language].GramPanchayatOffice}</td> */}

                    {/* Number Column */}
                    {/* <td className="p-2 border">
                        {isViewMode ? (
                          <div className="p-2 bg-gray-50 rounded">
                            {proposalData.section19_gram_panchayat_office_no || '-'}
                          </div>
                        ) : (
                          <input
                            type="text"
                            value={publishData.section19_gram_panchayat_office_no}
                            onChange={(e) =>
                              setPublishData({
                                ...publishData,
                                section19_gram_panchayat_office_no: e.target.value,
                              })
                            }
                            placeholder="Enter Gram Panchayat Office number"
                            className="w-full p-2 border rounded"
                          />
                        )}
                      </td> */}

                    {/* Date Column */}
                    {/* <td className="p-2 border">
                        {isViewMode ? (
                          <div className="p-2 bg-gray-50 rounded">
                            {formatDate(proposalData.section19_gram_panchayat_office) || '-'}
                          </div>
                        ) : (
                          <input
                            type="date"
                            value={publishData.section19_gram_panchayat_office}
                            onChange={(e) =>
                              setPublishData({
                                ...publishData,
                                section19_gram_panchayat_office: e.target.value,
                              })
                            }
                            className="w-full p-2 border rounded"
                          />
                        )}
                      </td> */}

                    {/* Document Column */}
                    {/* <td className="no-print p-2 border">
                        {isViewMode ? (
                          selectedDocuments['section19_gram_panchayat_office_img'] ||
                            proposalData.section19_gram_panchayat_office_img ? (
                            <button
                              type="button"
                              onClick={() => handleViewDocument(proposalData.section19_gram_panchayat_office_img)}
                              className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                            >
                              <Eye className="h-3 w-3" /> {translations[language].View}
                            </button>
                          ) : (
                            <span className="text-gray-500 text-xs">No document</span>
                          )
                        ) : (
                          <>
                            <input
                              type="file"
                              accept="image/*,.pdf"
                              onChange={(e) =>
                                handleImageUpload(
                                  'section19_gram_panchayat_office_img',
                                  e.target.files[0]
                                )
                              }
                              className="w-full p-2 border rounded text-xs"
                            />
                            {selectedDocuments['section19_gram_panchayat_office_img'] && (
                              <div className="mt-2 flex items-center justify-between p-2 bg-green-50 rounded-lg">
                                <p className="text-xs text-green-600 truncate max-w-[70%]">
                                  {translations[language]?.Selected}:{' '}
                                  {selectedDocuments['section19_gram_panchayat_office_img'].name}
                                </p>
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleViewDocument(
                                      selectedDocuments['section19_gram_panchayat_office_img']
                                    )
                                  }
                                  className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                                >
                                  <Eye className="h-3 w-3" /> {translations[language].View}
                                </button>
                              </div>
                            )}
                          </>
                        )}
                      </td>
                    </tr> */}

                    {/* Date of Notification Under Column 19 - No and Date */}
                    <tr>
                      <td className="p-2 border">10</td>
                      <td className="p-2 border">{translations[language].dateOfNotificationUnderColumn19}</td>

                      {/* Number Column */}
                      <td className="p-2 border">
                        {isViewMode ? (
                          <div className="p-2 bg-gray-50 rounded">
                            {proposalData.section19_rehabilitation_rights_notice_no || '-'}
                          </div>
                        ) : (
                          <input
                            type="text"
                            value={publishData.section19_rehabilitation_rights_notice_no}
                            onChange={(e) =>
                              setPublishData({
                                ...publishData,
                                section19_rehabilitation_rights_notice_no: e.target.value,
                              })
                            }
                            placeholder="Enter Date of Notification number"
                            className="w-full p-2 border rounded"
                          />
                        )}
                      </td>

                      {/* Date Column */}
                      <td className="p-2 border">
                        {isViewMode ? (
                          <div className="p-2 bg-gray-50 rounded">
                            {formatDate(proposalData.section19_rehabilitation_rights_notice) || '-'}
                          </div>
                        ) : (
                          <input
                            type="date"
                            value={publishData.section19_rehabilitation_rights_notice}
                            min={maxDateOf10}
                            onChange={(e) =>
                              setPublishData({
                                ...publishData,
                                section19_rehabilitation_rights_notice: e.target.value,
                              })
                            }
                            className="w-full p-2 border rounded"
                          />
                        )}
                      </td>

                      {/* Document Column */}
                      <td className="no-print p-2 border">
                        {isViewMode ? (
                          selectedDocuments['section19_rehabilitation_rights_notice_img'] ||
                            proposalData.section19_rehabilitation_rights_notice_img ? (
                            <button
                              type="button"
                              onClick={() => handleViewDocument(proposalData.section19_rehabilitation_rights_notice_img)}
                              className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                            >
                              <Eye className="h-3 w-3" /> {translations[language].View}
                            </button>
                          ) : (
                            <span className="text-gray-500 text-xs">No document</span>
                          )
                        ) : (
                          <>
                            <input
                              type="file"
                              accept="image/*,.pdf"
                              onChange={(e) =>
                                handleImageUpload(
                                  'section19_rehabilitation_rights_notice_img',
                                  e.target.files[0]
                                )
                              }
                              className="w-full p-2 border rounded text-xs"
                            />
                            {selectedDocuments['section19_rehabilitation_rights_notice_img'] && (
                              <div className="mt-2 flex items-center justify-between p-2 bg-green-50 rounded-lg">
                                <p className="text-xs text-green-600 truncate max-w-[70%]">
                                  {translations[language]?.Selected}:{' '}
                                  {selectedDocuments['section19_rehabilitation_rights_notice_img'].name}
                                </p>
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleViewDocument(
                                      selectedDocuments['section19_rehabilitation_rights_notice_img']
                                    )
                                  }
                                  className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                                >
                                  <Eye className="h-3 w-3" /> {translations[language].View}
                                </button>
                              </div>
                            )}
                          </>
                        )}
                      </td>
                    </tr>

                  </tbody>
                </table>
              </div>

              {/* Modal Actions */}
              {!isViewMode && (
                <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                  <button
                    onClick={() => setShowPublishModal(false)}
                    className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                    disabled={publishing}
                  >
                    {translations[language]?.Cancel}
                  </button>

                  <button
                    onClick={handlePublish}
                    disabled={publishing || !publishData.section19_published_gazette || !publishData.section19_published_newspaper1 || !publishData.section19_published_newspaper2 || !publishData.section19_municipal_authority || !publishData.section19_collector_office || !publishData.section19_sub_divisional_office || !publishData.section19_tehsil_office || !publishData.section19_government_notice_board || !publishData.section19_gram_sevak_office || !publishData.section19_rehabilitation_rights_notice}
                    className="px-4 py-2 bg-blue-700 text-white rounded-lg hover:bg-blue-800 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                  >
                    {publishing ? (
                      <>
                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                        {translations[language]?.Saving}
                      </>
                    ) : (
                      <>
                        <Globe className="mr-2 h-4 w-4" />
                        {translations[language]?.Section19Publication}
                      </>
                    )}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Send to Samanvay Modal */}
      {showSendToSamanvayModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
            <div className="p-6">

              {/* <div className="flex justify-between items-center mb-6"> */}
              {/* <h3 className="text-xl font-semibold text-gray-800">
                  {translations[language]?.SendToSamanvayOfficer}
                </h3> */}
              {/* <button
                  onClick={() => setshowSendToSamanvayModal(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <X className="h-6 w-6" />
                </button> */}
              {/* </div> */}

              <div className="space-y-4">
                {/* User Selection */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language]?.selectUserSamanvayOfficer} *
                  </label>
                  <select
                    value={selectedUserSamanvay}
                    onChange={(e) => setselectedUserSamanvay(e.target.value)}
                    disabled={loadingusersSamanvay}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="">
                      {loadingusersSamanvay ? translations[language]?.LoadingUsers : translations[language]?.SelectUser}
                    </option>
                    {usersSamanvay.map((user) => (
                      <option key={user.usr_id} value={user.usr_id}>
                        {user.full_name} ({user.usr_role})
                      </option>
                    ))}
                  </select>
                </div>

                {/* Remarks */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language]?.Remarks}
                  </label>
                  <textarea
                    value={remarksSamanvay}
                    onChange={(e) => setremarksSamanvay(e.target.value)}
                    rows={3}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Enter remarks..."
                  />
                </div>

                {/* Document Upload */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Upload Document *
                  </label>
                  <input
                    type="file"
                    onChange={(e) => setselectedDocumentSamanvay(e.target.files[0])}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  />
                </div>
              </div>

              {/* Modal Actions */}
              <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                <button
                  onClick={() => {
                    setshowSendToSamanvayModal(false);
                  }} className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                  disabled={sendingToSamanvay}
                >
                  {translations[language]?.Cancel}
                </button>
                <button
                  onClick={handleSendToSamanvay}
                  disabled={sendingToSamanvay || !selectedUserSamanvay || !selectedDocumentSamanvay}
                  className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                >
                  {sendingToSamanvay ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                      {translations[language]?.sending}
                    </>
                  ) : (
                    <>
                      <Send className="mr-2 h-4 w-4" />
                      {translations[language]?.CommonSave}
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Send to Collector Modal */}
      {showSendToCollectorModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              {/* <div className="flex justify-between items-center mb-6">
                <h3 className="text-xl font-semibold text-gray-800">
                  {translations[language]?.SendToCollector}
                </h3>
                <button
                  onClick={() => setshowSendToCollectorModal(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <X className="h-6 w-6" />
                </button>
              </div> */}

              <div className="space-y-4">
                {/* User Selection */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language]?.SelectUserCollector}*
                  </label>
                  <select
                    value={selectedUserCollector}
                    onChange={(e) => setselectedUserCollector(e.target.value)}
                    disabled={loadingusersCollector}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="">
                      {loadingusersCollector ? translations[language]?.LoadingUsers : translations[language]?.SelectUser}
                    </option>
                    {usersCollectorAll.map((user) => (
                      <option key={user.usr_id} value={user.usr_id}>
                        {user.full_name} ({user.usr_role || user.user_role})
                      </option>
                    ))}
                  </select>
                </div>

                {/* Remarks */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language]?.Remarks}
                  </label>
                  <textarea
                    value={remarksCollector}
                    onChange={(e) => setremarksCollector(e.target.value)}
                    rows={3}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Enter remarks..."
                  />
                </div>

                {/* Document Upload */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Upload Document *
                  </label>
                  <input
                    type="file"
                    onChange={(e) => setselectedDocumentCollector(e.target.files[0])}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  />

                </div>

                <div className="flex justify-start">
                  <button
                    onClick={handleCoveringLetterClick}
                    className="px-4 py-2 text-sm bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
                  >
                    कलम 19 मान्यता
                  </button>
                </div>
              </div>

              {/* Modal Actions */}
              <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                <button
                  onClick={() => {
                    setshowSendToCollectorModal(false);
                  }}
                  className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                  disabled={sendingToCollector}
                >
                  {translations[language]?.Cancel}
                </button>
                <button
                  onClick={handleSendToCollector}
                  disabled={sendingToCollector || !selectedUserCollector || !selectedDocumentCollector}
                  className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                >
                  {sendingToCollector ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                      {translations[language]?.Sending}
                    </>
                  ) : (
                    <>
                      <Send className="mr-2 h-4 w-4" />
                      {translations[language]?.CommonSave}
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Send to LAO Modal */}
      {showSendToLAOModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              {/* <div className="flex justify-between items-center mb-6">
                <h3 className="text-xl font-semibold text-gray-800">
                  {translations[language]?.SendBackToLAOOfficer}
                </h3>
                <button
                  onClick={() => setshowSendToLAOModal(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <X className="h-6 w-6" />
                </button>
              </div> */}

              <div className="space-y-4">
                {/* User Selection */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language]?.SelectUserLAO}*
                  </label>
                  <select
                    value={selectedUserLAO}
                    onChange={(e) => setselectedUserLAO(e.target.value)}
                    disabled={loadingusersLAO}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="">
                      {loadingusersLAO ? translations[language]?.LoadingUsers : translations[language]?.SelectUser}
                    </option>
                    {usersLAO.map((user) => (
                      <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                        {user.full_name || user.user_name} ({user.usr_role || user.user_role})
                      </option>
                    ))}
                  </select>
                </div>

                {/* Remarks */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language]?.Remarks}
                  </label>
                  <textarea
                    value={remarksLAO}
                    onChange={(e) => setremarksLAO(e.target.value)}
                    rows={3}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Enter remarks..."
                  />
                </div>

                {/* Document Upload */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Upload Document *
                  </label>
                  <input
                    type="file"
                    onChange={(e) => setselectedDocumentLAO(e.target.files[0])}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  />
                </div>
              </div>

              <div className="flex justify-start">
                <button
                  onClick={handleCoveringLetterClick}
                  className="px-4 py-2 text-sm bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
                >
                  कलम 19 मान्यता
                </button>
              </div>

              {/* Modal Actions */}
              <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                <button
                  onClick={() => {
                    setshowSendToLAOModal(false);
                  }}
                  className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                  disabled={sendingToLAO}
                >
                  {translations[language]?.Cancel}
                </button>
                <button
                  onClick={handleSendToLAO}
                  disabled={sendingToLAO || !selectedUserLAO || !selectedDocumentLAO}
                  className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                >
                  {sendingToLAO ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                      {translations[language]?.Sending}
                    </>
                  ) : (
                    <>
                      <Send className="mr-2 h-4 w-4" />
                      {translations[language]?.CommonSave}
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Unified Document Viewer Modal */}
      {showDocumentViewer && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-3xl w-full max-w-5xl h-[95vh] shadow-2xl overflow-hidden border border-gray-200">
            {/* Header */}
            <div className="flex justify-between items-center p-4 border-b border-gray-100 bg-gradient-to-r from-blue-50 to-indigo-50">
              <div className="flex items-center space-x-3">
                <h3 className="text-2xl font-bold text-gray-800 tracking-tight">Document Preview</h3>
              </div>
              <button
                onClick={closeDocumentViewer}
                className="w-10 h-10 rounded-full bg-gray-100 hover:bg-red-100 text-gray-500 hover:text-red-500 transition-all duration-200 flex items-center justify-center text-xl font-bold shadow-sm hover:shadow-md"
                aria-label="Close modal"
              >
                ×
              </button>
            </div>

            {/* Document Viewer Container */}
            <div className="h-[calc(95vh)] flex flex-col">
              <div className="flex-1 bg-gray-50 overflow-hidden shadow-inner border border-gray-200">
                {/* Document Content */}
                <div className="w-full h-full flex items-center justify-center">
                  {isPDFToView ? (
                    <iframe
                      src={fileUrlToView}
                      className="w-full h-full border-0 bg-white shadow-lg"
                      title="PDF Preview"
                    ></iframe>
                  ) : (
                    <img
                      src={fileUrlToView}
                      alt="File"
                      className="w-full h-full object-contain shadow-lg"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showAlertModal && (
        <div className="fixed top-4 right-4 z-50">
          <div className={`bg-white rounded-lg shadow-lg border-l-4 p-4 max-w-sm ${alertConfig.type === 'error' ? 'border-red-500' :
            alertConfig.type === 'warning' ? 'border-yellow-500' :
              alertConfig.type === 'info' ? 'border-blue-500' :
                'border-green-500'
            }`}>
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center ${alertConfig.type === 'error' ? 'bg-red-100' :
                  alertConfig.type === 'warning' ? 'bg-yellow-100' :
                    alertConfig.type === 'info' ? 'bg-blue-100' :
                      'bg-green-100'
                  }`}>
                  <span className={`font-bold ${alertConfig.type === 'error' ? 'text-red-600' :
                    alertConfig.type === 'warning' ? 'text-yellow-600' :
                      alertConfig.type === 'info' ? 'text-blue-600' :
                        'text-green-600'
                    }`}>
                    {alertConfig.type === 'error' ? '✕' :
                      alertConfig.type === 'warning' ? '⚠' :
                        alertConfig.type === 'info' ? 'ℹ' : '✓'}
                  </span>
                </div>
              </div>
              <div className="ml-3 flex-1">
                <h3 className="text-sm font-medium text-gray-900">{alertConfig.title}</h3>
                <p className="text-sm text-gray-600 mt-1">{alertConfig.message}</p>
              </div>
              <button
                onClick={() => setShowAlertModal(false)}
                className="ml-4 text-gray-400 hover:text-gray-600"
              >
                <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Confirmation Modal */}
      {showConfirmModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-sm mx-4">
            <div className="p-6">
              <div className={`w-12 h-12 rounded-full mx-auto mb-4 flex items-center justify-center ${confirmConfig.type === 'danger' ? 'bg-red-100' :
                confirmConfig.type === 'warning' ? 'bg-yellow-100' :
                  'bg-blue-100'
                }`}>
                {confirmConfig.type === 'danger' ? '⚠' :
                  confirmConfig.type === 'warning' ? '⚠' : '?'}
              </div>

              <h3 className="text-lg font-semibold text-gray-900 mb-2 text-center">
                {confirmConfig.title}
              </h3>

              <p className="text-gray-600 text-sm mb-6 text-center">
                {confirmConfig.message}
              </p>

              <div className="flex gap-3">
                <button
                  onClick={() => {
                    setShowConfirmModal(false);
                    if (confirmConfig.onCancel) confirmConfig.onCancel();
                  }}
                  className="flex-1 py-2 px-4 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors"
                >
                  {translations[language]?.Cancel}
                </button>
                <button
                  onClick={() => {
                    setShowConfirmModal(false);
                    if (confirmConfig.onConfirm) confirmConfig.onConfirm();
                  }}
                  className={`flex-1 py-2 px-4 text-white rounded-md transition-colors ${confirmConfig.type === 'danger' ? 'bg-red-600 hover:bg-red-700' :
                    confirmConfig.type === 'warning' ? 'bg-yellow-600 hover:bg-yellow-700' :
                      'bg-blue-600 hover:bg-blue-700'
                    }`}
                >
                  {translations[language]?.confirm}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RailwaySection19;